/**
 * Mock data for PACKOUT Wall Plate Builder configurator
 * Product ID: 338909191
 * This matches the exact structure from the real API response
 */
export const mockPackoutConfiguratorData = {
  brand: 'Milwaukee',
  productName: 'PACKOUT Wall Plate Builder',
  siteProductName: 'PACKOUT Wall Plate Builder',
  categoryLabel: 'Barn Doors',
  mainImageUrl: 'https://blinds.homedepot.com/product-images/d91edcca-9661-ec11-949a-0a986990730e.jpg',
  productType: 'Portable Storage',
  productId: 711698,
  variantId: 0,
  partnerProductId: 338909191,
  groups: [
    {
      name: 'Ungrouped',
      sequenceNumber: 0,
      options: [
        {
          isActive: true,
          isRequired: false,
          isHidden: false,
          isVisualized: false,
          isDependent: false,
          isIndexable: false,
          internalName: 'WALL_PLATE_WALL_PLATES',
          isInternalOnly: false,
          shortLabel: 'WALL PLATES',
          longLabel: 'WALL PLATES',
          optionType: null,
          description: '',
          id: 15584,
          presentationName: 'WALL PLATES',
          "choices": [
              {
                  "id": 265405,
                  "mediaUrl": "https://blinds.homedepot.com/product-images/c03647e2-9acc-f011-848f-0afffee37a07.png",
                  "media": {
                      "alternateText": "wallplate large",
                      "caption": null,
                      "mediaOwner": null
                  },
                  "isActive": true,
                  "internalName": "_PACKOUT_LARGE_WALL_PLATE",
                  "shortLabel": "PACKOUT LARGE WALL PLATE",
                  "longLabel": "PACKOUT LARGE WALL PLATE",
                  "siteProductOptionChoiceShortLabel": null,
                  "siteProductOptionChoiceLongLabel": null,
                  "price": 0.0,
                  "sequence": 1,
                  "isSelected": false,
                  "isDefault": false,
                  "isBackordered": false,
                  "fillDate": null,
                  "value": null,
                  "minValue": 0.0,
                  "maxValue": 0.0,
                  "tags": [],
                  "fullPath": "WALL_PLATE_WALL_PLATES",
                  "metaDataItems": [
                      {
                          "metaDataId": 10838,
                          "name": "Sku",
                          "value": "329930935",
                          "type": "string"
                      },
                      {
                          "metaDataId": 18567,
                          "name": "isBase",
                          "value": "true",
                          "type": "string"
                      },
                      {
                          "metaDataId": 18644,
                          "name": "height",
                          "value": "20",
                          "type": "decimal"
                      },
                      {
                          "metaDataId": 18645,
                          "name": "width",
                          "value": "30.75",
                          "type": "decimal"
                      },
                      {
                          "metaDataId": 186481,
                          "name": "anchorpointDimensions",
                          "value": {
                              "width":3.7,
                              "height":3.8
                            },
                          "type": "json"
                      },
                      {
                          "metaDataId": 186482,
                          "name": "anchorpointOffsets",
                          "value": {
                              "top":4.2,
                              "left":1.5,
                              "footPrint":2.45,
                              "row":0.4,
                              "column": 0.4
                            },
                          "type": "json"
                      },
                      {
                          "metaDataId": 186483,
                          "name": "anchorpointBuildPattern",
                          "value": {
                              "type":"grid",
                              "rows":3,
                              "footPrints":3,
                              "columnsPerFootPrint":2
                            }
                          ,
                          "type": "json"
                      },
                      {
                          "metaDataId": 186484,
                          "name": "anchorpointType",
                          "value": "cleat",
                          "type": "string"
                      },
                      {
                          "metaDataId": 18661,
                          "name": "componentType",
                          "value": "mount-surface",
                          "type": "string"
                      },
                      {
                          "metaDataId": 18940,
                          "name": "gridColumns",
                          "value": "3",
                          "type": "int"
                      },
                      {
                          "metaDataId": 18941,
                          "name": "gridRows",
                          "value": "1",
                          "type": "int"
                      },
                      {
                          "metaDataId": 189463,
                          "name": "snapBehavior",
                          "value": "{\"overlap\":{\"left\":0,\"right\":0}}",
                          "type": "string"
                      }
                  ],
                  "dependentOptions": [],
                  "dataType": "List"
              },
              {
                  "id": 265412,
                  "mediaUrl": "https://blinds.homedepot.com/product-images/d0301aef-9acc-f011-848f-0afffee37a07.png",
                  "media": {
                      "alternateText": "wallplate compact",
                      "caption": null,
                      "mediaOwner": null
                  },
                  "isActive": true,
                  "internalName": "_PACKOUT_COMPACT_WALL_PLATE",
                  "shortLabel": "PACKOUT COMPACT WALL PLATE",
                  "longLabel": "PACKOUT COMPACT WALL PLATE",
                  "siteProductOptionChoiceShortLabel": null,
                  "siteProductOptionChoiceLongLabel": null,
                  "price": 0.0,
                  "sequence": 2,
                  "isSelected": false,
                  "isDefault": false,
                  "isBackordered": false,
                  "fillDate": null,
                  "value": null,
                  "minValue": 0.0,
                  "maxValue": 0.0,
                  "tags": [],
                  "fullPath": "WALL_PLATE_WALL_PLATES",
                  "metaDataItems": [
                      {
                          "metaDataId": 10830,
                          "name": "Sku",
                          "value": "329930718",
                          "type": "string"
                      },
                      {
                          "metaDataId": 18568,
                          "name": "isBase",
                          "value": "true",
                          "type": "string"
                      },
                      {
                          "metaDataId": 18642,
                          "name": "height",
                          "value": "20",
                          "type": "decimal"
                      },
                      {
                          "metaDataId": 18643,
                          "name": "width",
                          "value": "10.25",
                          "type": "decimal"
                      },
                      {
                          "metaDataId": 18654,
                          "name": "anchorPointConfig",
                           "value": "{\"width\":3.7,\"height\":3.8,\"type\":\"cleat\",\"offSets\":{\"top\":4.2,\"left\":1.5,\"footPrint\":2.4,\"row\":0.4,\"column\": 0.4},\"buildPattern\":{\"type\":\"grid\",\"rows\":3,\"footPrints\":1,\"columnsPerFootPrint\":2}}",
                          "type": "string"
                      },
                      {
                          "metaDataId": 18752,
                          "name": "componentType",
                          "value": "mount-surface",
                          "type": "string"
                      },
                      {
                          "metaDataId": 18945,
                          "name": "gridRows",
                          "value": "1",
                          "type": "int"
                      },
                      {
                          "metaDataId": 18946,
                          "name": "gridColumns",
                          "value": "1",
                          "type": "int"
                      },
                      {
                          "metaDataId": 189463,
                          "name": "snapBehavior",
                          "value": "{\"overlap\":{\"left\":0,\"right\":0}}",
                          "type": "string"
                      }
                  ],
                  "dependentOptions": [],
                  "dataType": "List"
              },
              // ── Mock: WallStorage 2-plate horizontal bundle ───────────────────
              // Design ID maps to mock-data/bundle-designs/wallStorage-bundle.mock.js
              // Footprint: 6 cols × 1 row  (two 3-wide plates side by side)
              {
                  "id": 280001,
                  "mediaUrl": "https://blinds.homedepot.com/product-images/c03647e2-9acc-f011-848f-0afffee37a07.png",
                  "media": { "alternateText": "2-Plate Wall Bundle", "caption": null, "mediaOwner": null },
                  "isActive": true,
                  "internalName": "MOCK_WALL_BUNDLE_2PLATE",
                  "shortLabel": "2-Plate Bundle (mock)",
                  "longLabel": "PACKOUT 2×Large Wall Plate Bundle",
                  "siteProductOptionChoiceShortLabel": null,
                  "siteProductOptionChoiceLongLabel": null,
                  "price": 78.91,
                  "sequence": 3,
                  "isSelected": false,
                  "isDefault": false,
                  "isBackordered": false,
                  "fillDate": null,
                  "value": null,
                  "minValue": 0.0,
                  "maxValue": 0.0,
                  "tags": [],
                  "fullPath": "WALL_PLATE_WALL_PLATES",
                  "metaDataItems": [
                      { "metaDataId": 28001, "name": "isBase",        "value": "true",                                    "type": "string" },
                      { "metaDataId": 28002, "name": "BundleDesign",  "value": "8f0af0eb-0000-0000-0000-mock00000001",     "type": "string" },
                      { "metaDataId": 28003, "name": "gridColumns",   "value": "6",                                       "type": "int" },
                      { "metaDataId": 28004, "name": "gridRows",      "value": "1",                                       "type": "int" },
                      { "metaDataId": 28005, "name": "width",         "value": "61.50",                                   "type": "decimal" },
                      { "metaDataId": 28006, "name": "height",        "value": "20",                                      "type": "decimal" }
                  ],
                  "dependentOptions": [],
                  "dataType": "List"
              },

              // ── Mock: VehicleStorage (Rack) bundle with partial null SKUs ─────
              // Design ID maps to mock-data/bundle-designs/vehicleStorage-bundle.mock.js
              // floorOnly=true → placed on floor, not wall grid
              {
                  "id": 280002,
                  "mediaUrl": "https://gcc-visualizer-images.s3.us-east-1.amazonaws.com/is/image/VehicleStorage/682010+-+Packout+Vehicle+Storage/712166_222222_1.png",
                  "media": { "alternateText": "Rack Bundle", "caption": null, "mediaOwner": null },
                  "isActive": true,
                  "internalName": "MOCK_RACK_BUNDLE",
                  "shortLabel": "Rack Bundle (mock)",
                  "longLabel": "PACKOUT Rack + Frame Bundle",
                  "siteProductOptionChoiceShortLabel": null,
                  "siteProductOptionChoiceLongLabel": null,
                  "price": 570.79,
                  "sequence": 4,
                  "isSelected": false,
                  "isDefault": false,
                  "isBackordered": false,
                  "fillDate": null,
                  "value": null,
                  "minValue": 0.0,
                  "maxValue": 0.0,
                  "tags": [],
                  "fullPath": "WALL_PLATE_WALL_PLATES",
                  "metaDataItems": [
                      { "metaDataId": 28011, "name": "isBase",        "value": "true",                                    "type": "string" },
                      { "metaDataId": 28012, "name": "BundleDesign",  "value": "15a265db-0000-0000-0000-mock00000002",    "type": "string" },
                      { "metaDataId": 28013, "name": "floorOnly",     "value": "true",                                    "type": "string" },
                      { "metaDataId": 28014, "name": "width",         "value": "27.30",                                   "type": "decimal" },
                      { "metaDataId": 28015, "name": "height",        "value": "35.95",                                   "type": "decimal" },
                      { "metaDataId": 28016, "name": "dimensions",    "value": "27.30x35.95",                             "type": "string" }
                  ],
                  "dependentOptions": [],
                  "dataType": "List"
              },
              // Mock: VehicleStorage Hardbundle
              {
                  "id": 280003,
                  "mediaUrl": "https://gcc-visualizer-images.s3.us-east-1.amazonaws.com/is/image/VehicleStorage/682010+-+Packout+Vehicle+Storage/712166_222222_1.png",
                  "media": { "alternateText": "Rack Bundle Hard bundle", "caption": null, "mediaOwner": null },
                  "isActive": true,
                  "internalName": "MOCK_RACK_BUNDLE",
                  "shortLabel": "Rack Bundle (mock)",
                  "longLabel": "PACKOUT Rack + Frame Bundle",
                  "siteProductOptionChoiceShortLabel": null,
                  "siteProductOptionChoiceLongLabel": null,
                  "price": 570.79,
                  "sequence": 4,
                  "isSelected": false,
                  "isDefault": false,
                  "isBackordered": false,
                  "fillDate": null,
                  "value": null,
                  "minValue": 0.0,
                  "maxValue": 0.0,
                  "tags": [],
                  "fullPath": "WALL_PLATE_WALL_PLATES",
                  "metaDataItems": [
                      { "metaDataId": 28011, "name": "isBase",        "value": "true",                                    "type": "string" },
                      { "metaDataId": 28012, "name": "BundleDesign",  "value": "15a265db-0000-0000-0000-mock00000003",    "type": "string" },
                      { "metaDataId": 28013, "name": "floorOnly",     "value": "true",                                    "type": "string" },
                      { "metaDataId": 28014, "name": "width",         "value": "27.30",                                   "type": "decimal" },
                      { "metaDataId": 28015, "name": "height",        "value": "35.95",                                   "type": "decimal" },
                      { "metaDataId": 28016, "name": "dimensions",    "value": "27.30x35.95",                             "type": "string" }
                  ],
                  "dependentOptions": [],
                  "dataType": "List"
              },

              // ── Mock: WallStorage 2-plate loaded bundle ───────────────────────
              // Design ID maps to mock-data/bundle-designs/wallStorage-bundle-loaded.mock.js
              // Footprint: 6 cols × 1 row (two 3-wide plates side by side, pre-loaded
              // with a rack, cabinet, organizer and hooks)
              {
                  "id": 280004,
                  "mediaUrl": "https://blinds.homedepot.com/is/image/blinds/711698_265405_0?fmt=png",
                  "media": { "alternateText": "2-Plate Loaded Wall Bundle", "caption": null, "mediaOwner": null },
                  "isActive": true,
                  "internalName": "MOCK_WALL_BUNDLE_2PLATE_LOADED",
                  "shortLabel": "2-Plate Loaded Bundle (mock)",
                  "longLabel": "PACKOUT 2×Large Wall Plate Loaded Bundle",
                  "siteProductOptionChoiceShortLabel": null,
                  "siteProductOptionChoiceLongLabel": null,
                  "price": 249.97,
                  "sequence": 5,
                  "isSelected": false,
                  "isDefault": false,
                  "isBackordered": false,
                  "fillDate": null,
                  "value": null,
                  "minValue": 0.0,
                  "maxValue": 0.0,
                  "tags": [],
                  "fullPath": "WALL_PLATE_WALL_PLATES",
                  "metaDataItems": [
                      { "metaDataId": 28021, "name": "isBase",        "value": "true",                                    "type": "string" },
                      { "metaDataId": 28022, "name": "BundleDesign",  "value": "8f0af0eb-0000-0000-0000-mock00000004",     "type": "string" },
                      { "metaDataId": 28023, "name": "gridColumns",   "value": "6",                                       "type": "int" },
                      { "metaDataId": 28024, "name": "gridRows",      "value": "1",                                       "type": "int" },
                      { "metaDataId": 28025, "name": "width",         "value": "61.50",                                   "type": "decimal" },
                      { "metaDataId": 28026, "name": "height",        "value": "20",                                      "type": "decimal" }
                  ],
                  "dependentOptions": [],
                  "dataType": "List"
              },

              // ── Mock: WallStorage single-SKU bundle (Ryobi combo kit) ─────────
              // Design ID maps to mock-data/bundle-designs/wallStorage-singleSku-bundle.mock.js
              // Design-level Sku marks it as one packaged unit split into independent
              // part images (drill/battery/charger) grouped via a placement-time bundleInstanceId.
              {
                  "id": 280005,
                  "mediaUrl": "https://blinds.homedepot.com/is/image/blinds/711698_265405_0?fmt=png",
                  "media": { "alternateText": "Ryobi Combo Kit Bundle", "caption": null, "mediaOwner": null },
                  "isActive": true,
                  "internalName": "MOCK_SINGLE_SKU_BUNDLE_RYOBI",
                  "shortLabel": "Ryobi Combo Kit (mock)",
                  "longLabel": "RYOBI 18V Combo Kit (Single-SKU Bundle)",
                  "siteProductOptionChoiceShortLabel": null,
                  "siteProductOptionChoiceLongLabel": null,
                  "price": 199.00,
                  "sequence": 6,
                  "isSelected": false,
                  "isDefault": false,
                  "isBackordered": false,
                  "fillDate": null,
                  "value": null,
                  "minValue": 0.0,
                  "maxValue": 0.0,
                  "tags": [],
                  "fullPath": "WALL_PLATE_WALL_PLATES",
                  "metaDataItems": [
                      { "metaDataId": 28031, "name": "isBase",        "value": "true",                                    "type": "string" },
                      { "metaDataId": 28032, "name": "BundleDesign",  "value": "8f0af0eb-0000-0000-0000-mock00000005",     "type": "string" },
                      { "metaDataId": 28033, "name": "width",         "value": "10.00",                                   "type": "decimal" },
                      { "metaDataId": 28034, "name": "height",        "value": "8.00",                                    "type": "decimal" }
                  ],
                  "dependentOptions": [],
                  "dataType": "List"
              }
          ],
          sequence: 2,
          groupSequence: 2,
          tags: [],
          choiceGroups: []
        },
        {
          isActive: true,
          isRequired: false,
          isHidden: false,
          isVisualized: false,
          isDependent: false,
          isIndexable: false,
          internalName: 'WALL_PLATE_HOOKS',
          isInternalOnly: false,
          shortLabel: 'HOOKS',
          longLabel: 'HOOKS',
          optionType: null,
          description: '',
          id: 15585,
          presentationName: 'HOOKS',
                    "choices": [
                        {
                            "id": 265416,
                            "mediaUrl": "https://blinds.homedepot.com/product-images/fcd74a8e-83d0-f011-848f-0afffee37a07.png",
                            "media": {
                                "alternateText": "PACKOUT 4\" SINGLE STRAIGHT HOOK",
                                "caption": null,
                                "mediaOwner": null
                            },
                            "isActive": true,
                            "internalName": "_PACKOUT_4_SINGLE_STRAIGHT_HOOK",
                            "shortLabel": "PACKOUT 4\" SINGLE STRAIGHT HOOK",
                            "longLabel": "PACKOUT 4\" SINGLE STRAIGHT HOOK",
                            "siteProductOptionChoiceShortLabel": null,
                            "siteProductOptionChoiceLongLabel": null,
                            "price": 0.0,
                            "sequence": 1,
                            "isSelected": false,
                            "isDefault": false,
                            "isBackordered": false,
                            "fillDate": null,
                            "value": null,
                            "minValue": 0.0,
                            "maxValue": 0.0,
                            "tags": [],
                            "fullPath": "WALL_PLATE_HOOKS",
                            "metaDataItems": [
                                {
                                    "metaDataId": 10848,
                                    "name": "Sku",
                                    "value": "325001889",
                                    "type": "string"
                                },
                                {
                                    "metaDataId": 19128,
                                    "name": "width",
                                    "value": "3.5",
                                    "type": "decimal"
                                },
                                {
                                    "metaDataId": 19129,
                                    "name": "height",
                                    "value": "4",
                                    "type": "decimal"
                                },
                                {
                                    "metaDataId": 19242,
                                    "name": "attachConfig",
                                    "value": "{\"parentTypes\":[\"mount-surface\"],\"anchorPointTypes\":[\"cleat\"],\"anchorPattern\": \"1x1\",\"maxFootPrintSpan\":1,\"offsets\":{\"top\":1.2,\"left\":0}}",
                                    "type": "string"
                                }
                            ],
                            "dependentOptions": [],
                            "dataType": "List"
                        },
                        {
                            "id": 265417,
                            "mediaUrl": "https://blinds.homedepot.com/product-images/6fffa0a1-83d0-f011-848f-0afffee37a07.png",
                            "media": {
                                "alternateText": "PACKOUT 7-HOOK RACK",
                                "caption": null,
                                "mediaOwner": null
                            },
                            "isActive": true,
                            "internalName": "_PACKOUT_7HOOK_RACK",
                            "shortLabel": "PACKOUT 7-HOOK RACK",
                            "longLabel": "PACKOUT 7-HOOK RACK",
                            "siteProductOptionChoiceShortLabel": null,
                            "siteProductOptionChoiceLongLabel": null,
                            "price": 0.0,
                            "sequence": 2,
                            "isSelected": false,
                            "isDefault": false,
                            "isBackordered": false,
                            "fillDate": null,
                            "value": null,
                            "minValue": 0.0,
                            "maxValue": 0.0,
                            "tags": [],
                            "fullPath": "WALL_PLATE_HOOKS",
                            "metaDataItems": [
                                {
                                    "metaDataId": 10847,
                                    "name": "Sku",
                                    "value": "325001890",
                                    "type": "string"
                                },
                                {
                                    "metaDataId": 18870,
                                    "name": "height",
                                    "value": "3.5",
                                    "type": "decimal"
                                },
                                {
                                    "metaDataId": 18871,
                                    "name": "width",
                                    "value": "9.5",
                                    "type": "decimal"
                                },
                                {
                                    "metaDataId": 18872,
                                    "name": "attachConfig",
                                    "value": "{\"parentTypes\":[\"mount-surface\"],\"anchorPointTypes\":[\"cleat\"],\"anchorPattern\": \"2x1\",\"maxFootPrintSpan\":1,\"offsets\":{\"top\":0.7,\"left\":-0.6}}",
                                    "type": "string"
                                }
                            ],
                            "dependentOptions": [],
                            "dataType": "List"
                        },
                        {
                            "id": 265424,
                            "mediaUrl": "https://blinds.homedepot.com/product-images/071b6eb1-8bd0-f011-848f-0afffee37a07.png",
                            "media": {
                                "alternateText": "PACKOUT 9\" STRAIGHT HOOK",
                                "caption": null,
                                "mediaOwner": null
                            },
                            "isActive": true,
                            "internalName": "_PACKOUT_9_STRAIGHT_HOOK",
                            "shortLabel": "PACKOUT 9\" STRAIGHT HOOK",
                            "longLabel": "PACKOUT 9\" STRAIGHT HOOK",
                            "siteProductOptionChoiceShortLabel": null,
                            "siteProductOptionChoiceLongLabel": null,
                            "price": 0.0,
                            "sequence": 3,
                            "isSelected": false,
                            "isDefault": false,
                            "isBackordered": false,
                            "fillDate": null,
                            "value": null,
                            "minValue": 0.0,
                            "maxValue": 0.0,
                            "tags": [],
                            "fullPath": "WALL_PLATE_HOOKS",
                            "metaDataItems": [
                                {
                                    "metaDataId": 10844,
                                    "name": "Sku",
                                    "value": "320026102",
                                    "type": "string"
                                },
                                {
                                    "metaDataId": 18889,
                                    "name": "width",
                                    "value": "3.5",
                                    "type": "decimal"
                                },
                                {
                                    "metaDataId": 18890,
                                    "name": "height",
                                    "value": "8",
                                    "type": "decimal"
                                },
                                {
                                    "metaDataId": 18891,
                                    "name": "attachConfig",
                                    "value": "{\"parentTypes\":[\"mount-surface\"],\"anchorPointTypes\":[\"cleat\"],\"anchorPattern\": \"1x2\",\"maxFootPrintSpan\":1,\"offsets\":{\"top\":3.5,\"left\":0}}",
                                    "type": "string"
                                }
                            ],
                            "dependentOptions": [],
                            "dataType": "List"
                        },
                        {
                            "id": 265419,
                            "mediaUrl": "https://blinds.homedepot.com/product-images/9eb112ae-71d4-f011-848f-0afffee37a07.png",
                            "media": {
                                "alternateText": "PACKOUT 6\" CURVED HOOK",
                                "caption": null,
                                "mediaOwner": null
                            },
                            "isActive": true,
                            "internalName": "_PACKOUT_6_CURVED_HOOK",
                            "shortLabel": "PACKOUT 6\" CURVED HOOK",
                            "longLabel": "PACKOUT 6\" CURVED HOOK",
                            "siteProductOptionChoiceShortLabel": null,
                            "siteProductOptionChoiceLongLabel": null,
                            "price": 0.0,
                            "sequence": 4,
                            "isSelected": false,
                            "isDefault": false,
                            "isBackordered": false,
                            "fillDate": null,
                            "value": null,
                            "minValue": 0.0,
                            "maxValue": 0.0,
                            "tags": [],
                            "fullPath": "WALL_PLATE_HOOKS",
                            "metaDataItems": [
                                {
                                    "metaDataId": 10842,
                                    "name": "Sku",
                                    "value": "320026716",
                                    "type": "string"
                                },
                                {
                                    "metaDataId": 18886,
                                    "name": "width",
                                    "value": "3.5",
                                    "type": "decimal"
                                },
                                {
                                    "metaDataId": 18887,
                                    "name": "height",
                                    "value": "9",
                                    "type": "decimal"
                                },
                                {
                                    "metaDataId": 18888,
                                    "name": "attachConfig",
                                    "value": "{\"parentTypes\":[\"mount-surface\"],\"anchorPointTypes\":[\"cleat\"],\"anchorPattern\": \"1x2\",\"maxFootPrintSpan\":1,\"offsets\":{\"top\":3.5,\"left\":0}}",
                                    "type": "string"
                                }
                            ],
                            "dependentOptions": [],
                            "dataType": "List"
                        },
                        {
                            "id": 265423,
                            "mediaUrl": "https://blinds.homedepot.com/product-images/14fc5df3-71d4-f011-848f-0afffee37a07.png",
                            "media": {
                                "alternateText": "PACKOUT WIDE HOOK",
                                "caption": null,
                                "mediaOwner": null
                            },
                            "isActive": true,
                            "internalName": "_PACKOUT_WIDE_HOOK",
                            "shortLabel": "PACKOUT WIDE HOOK",
                            "longLabel": "PACKOUT WIDE HOOK",
                            "siteProductOptionChoiceShortLabel": null,
                            "siteProductOptionChoiceLongLabel": null,
                            "price": 0.0,
                            "sequence": 5,
                            "isSelected": false,
                            "isDefault": false,
                            "isBackordered": false,
                            "fillDate": null,
                            "value": null,
                            "minValue": 0.0,
                            "maxValue": 0.0,
                            "tags": [],
                            "fullPath": "WALL_PLATE_HOOKS",
                            "metaDataItems": [
                                {
                                    "metaDataId": 10845,
                                    "name": "Sku",
                                    "value": "320052193",
                                    "type": "string"
                                },
                                {
                                    "metaDataId": 18734,
                                    "name": "attachConfig",
                                    "value": "{\"parentTypes\":[\"mount-surface\"],\"anchorPointTypes\":[\"cleat\"],\"anchorPattern\": \"1x2\",\"maxFootPrintSpan\":1,\"offsets\":{\"top\":1,\"left\":-1.8},\"onePerFootPrint\":true,\"zIndex\":99}",
                                    "type": "string"
                                },
                                {
                                    "metaDataId": 18841,
                                    "name": "height",
                                    "value": "8.5",
                                    "type": "decimal"
                                },
                                {
                                    "metaDataId": 18842,
                                    "name": "width",
                                    "value": "7",
                                    "type": "decimal"
                                }
                            ],
                            "dependentOptions": [],
                            "dataType": "List"
                        },
                        {
                            "id": 265418,
                            "mediaUrl": "https://blinds.homedepot.com/product-images/5f4ccab9-83d0-f011-848f-0afffee37a07.png",
                            "media": {
                                "alternateText": "PACKOUT 4\" S HOOK",
                                "caption": null,
                                "mediaOwner": null
                            },
                            "isActive": true,
                            "internalName": "_PACKOUT_4_S_HOOK",
                            "shortLabel": "PACKOUT 4\" S HOOK",
                            "longLabel": "PACKOUT 4\" S HOOK",
                            "siteProductOptionChoiceShortLabel": null,
                            "siteProductOptionChoiceLongLabel": null,
                            "price": 0.0,
                            "sequence": 6,
                            "isSelected": false,
                            "isDefault": false,
                            "isBackordered": false,
                            "fillDate": null,
                            "value": null,
                            "minValue": 0.0,
                            "maxValue": 0.0,
                            "tags": [],
                            "fullPath": "WALL_PLATE_HOOKS",
                            "metaDataItems": [
                                {
                                    "metaDataId": 10841,
                                    "name": "Sku",
                                    "value": "320052375",
                                    "type": "string"
                                },
                                {
                                    "metaDataId": 19130,
                                    "name": "height",
                                    "value": "7",
                                    "type": "decimal"
                                },
                                {
                                    "metaDataId": 19131,
                                    "name": "width",
                                    "value": "3.5",
                                    "type": "decimal"
                                },
                                {
                                    "metaDataId": 19243,
                                    "name": "attachConfig",
                                    "value": "{\"parentTypes\":[\"mount-surface\"],\"anchorPointTypes\":[\"cleat\"],\"anchorPattern\": \"1x2\",\"maxFootPrintSpan\":1,\"offsets\":{\"top\":1,\"left\":0}}",
                                    "type": "string"
                                }
                            ],
                            "dependentOptions": [],
                            "dataType": "List"
                        },
                        {
                            "id": 265422,
                            "mediaUrl": "https://blinds.homedepot.com/product-images/203c9ef7-8ad0-f011-848f-0afffee37a07.png",
                            "media": {
                                "alternateText": "PACKOUT 4\" STRAIGHT HOOK",
                                "caption": null,
                                "mediaOwner": null
                            },
                            "isActive": true,
                            "internalName": "_PACKOUT_4_STRAIGHT_HOOK",
                            "shortLabel": "PACKOUT 4\" STRAIGHT HOOK",
                            "longLabel": "PACKOUT 4\" STRAIGHT HOOK",
                            "siteProductOptionChoiceShortLabel": null,
                            "siteProductOptionChoiceLongLabel": null,
                            "price": 0.0,
                            "sequence": 6,
                            "isSelected": false,
                            "isDefault": false,
                            "isBackordered": false,
                            "fillDate": null,
                            "value": null,
                            "minValue": 0.0,
                            "maxValue": 0.0,
                            "tags": [],
                            "fullPath": "WALL_PLATE_HOOKS",
                            "metaDataItems": [
                                {
                                    "metaDataId": 10839,
                                    "name": "Sku",
                                    "value": "320052829",
                                    "type": "string"
                                },
                                {
                                    "metaDataId": 19132,
                                    "name": "height",
                                    "value": "4",
                                    "type": "decimal"
                                },
                                {
                                    "metaDataId": 19133,
                                    "name": "width",
                                    "value": "3.5",
                                    "type": "decimal"
                                },
                                {
                                    "metaDataId": 19244,
                                    "name": "attachConfig",
                                    "value": "{\"parentTypes\":[\"mount-surface\"],\"anchorPointTypes\":[\"cleat\"],\"anchorPattern\": \"1x1\",\"maxFootPrintSpan\":1,\"offsets\":{\"top\":1,\"left\":0}}",
                                    "type": "string"
                                }
                            ],
                            "dependentOptions": [],
                            "dataType": "List"
                        },
                        {
                            "id": 265420,
                            "mediaUrl": "https://blinds.homedepot.com/product-images/2420bcde-71d4-f011-848f-0afffee37a07.png",
                            "media": {
                                "alternateText": "PACKOUT 3\" CURVED HOOK",
                                "caption": null,
                                "mediaOwner": null
                            },
                            "isActive": true,
                            "internalName": "_PACKOUT_3_CURVED_HOOK",
                            "shortLabel": "PACKOUT 3\" CURVED HOOK",
                            "longLabel": "PACKOUT 3\" CURVED HOOK",
                            "siteProductOptionChoiceShortLabel": null,
                            "siteProductOptionChoiceLongLabel": null,
                            "price": 0.0,
                            "sequence": 8,
                            "isSelected": false,
                            "isDefault": false,
                            "isBackordered": false,
                            "fillDate": null,
                            "value": null,
                            "minValue": 0.0,
                            "maxValue": 0.0,
                            "tags": [],
                            "fullPath": "WALL_PLATE_HOOKS",
                            "metaDataItems": [
                                {
                                    "metaDataId": 10843,
                                    "name": "Sku",
                                    "value": "320089458",
                                    "type": "string"
                                },
                                {
                                    "metaDataId": 18735,
                                    "name": "attachConfig",
                                    "value": "{\"parentTypes\":[\"mount-surface\"],\"anchorPointTypes\":[\"cleat\"],\"anchorPattern\": \"1x1\",\"maxFootPrintSpan\":1,\"offsets\":{\"top\":1,\"left\":0.1}}",
                                    "type": "string"
                                },
                                {
                                    "metaDataId": 18819,
                                    "name": "height",
                                    "value": "4",
                                    "type": "decimal"
                                },
                                {
                                    "metaDataId": 18820,
                                    "name": "width",
                                    "value": "3.5",
                                    "type": "decimal"
                                }
                            ],
                            "dependentOptions": [],
                            "dataType": "List"
                        },

                        // ── Mock: catalog entries for wallStorage-bundle-loaded.mock.js accessories ──
                        // These choiceIds are referenced by that bundle's DesignDocument.Products[].ChoiceId
                        // but had no matching catalog choice, so bundleChoiceMetadata resolved to {} and
                        // attachConfig was null — getAvailableAnchorPoints bails out with no dropzones
                        // for that product on ANY parent (not just the "other" plate).
                        {
                            "id": 265400,
                            "mediaUrl": "https://blinds.homedepot.com/is/image/blinds/711698_265400_0?fmt=png",
                            "media": { "alternateText": "PACKOUT 5-COMPARTMENT ORGANIZER", "caption": null, "mediaOwner": null },
                            "isActive": true,
                            "internalName": "_PACKOUT_5COMP_LOWPROFILE_ORGANIZER",
                            "shortLabel": "PACKOUT 5-COMPARTMENT ORGANIZER",
                            "longLabel": "PACKOUT 5-Compartment Low-Profile Compact Small Parts Organizer",
                            "siteProductOptionChoiceShortLabel": null,
                            "siteProductOptionChoiceLongLabel": null,
                            "price": 0.0,
                            "sequence": 9,
                            "isSelected": false,
                            "isDefault": false,
                            "isBackordered": false,
                            "fillDate": null,
                            "value": null,
                            "minValue": 0.0,
                            "maxValue": 0.0,
                            "tags": [],
                            "fullPath": "WALL_PLATE_HOOKS",
                            "metaDataItems": [
                                { "metaDataId": 30001, "name": "Sku", "value": "305821962", "type": "string" },
                                { "metaDataId": 30002, "name": "height", "value": "16.2", "type": "decimal" },
                                { "metaDataId": 30003, "name": "width", "value": "9.8", "type": "decimal" },
                                {
                                    "metaDataId": 30004,
                                    "name": "attachConfig",
                                    "value": "{\"parentTypes\":[\"mount-surface\"],\"anchorPointTypes\":[\"cleat\"],\"anchorPattern\": \"2x3\",\"maxFootPrintSpan\":1,\"offsets\":{\"top\":-1.8,\"left\":-1.2}}",
                                    "type": "string"
                                }
                            ],
                            "dependentOptions": [],
                            "dataType": "List"
                        },
                        {
                            "id": 265425,
                            "mediaUrl": "https://blinds.homedepot.com/is/image/blinds/711698_265425_0?fmt=png",
                            "media": { "alternateText": "PACKOUT 19.5in CABINET", "caption": null, "mediaOwner": null },
                            "isActive": true,
                            "internalName": "_PACKOUT_CABINET_RED_1PC",
                            "shortLabel": "PACKOUT 19.5in CABINET",
                            "longLabel": "Packout 19.5 in. W x 14.7 in. H x 14.5 in. D Cabinet in Red (1-Piece)",
                            "siteProductOptionChoiceShortLabel": null,
                            "siteProductOptionChoiceLongLabel": null,
                            "price": 0.0,
                            "sequence": 10,
                            "isSelected": false,
                            "isDefault": false,
                            "isBackordered": false,
                            "fillDate": null,
                            "value": null,
                            "minValue": 0.0,
                            "maxValue": 0.0,
                            "tags": [],
                            "fullPath": "WALL_PLATE_HOOKS",
                            "metaDataItems": [
                                { "metaDataId": 30005, "name": "Sku", "value": "320324795", "type": "string" },
                                { "metaDataId": 30006, "name": "height", "value": "14.7", "type": "decimal" },
                                { "metaDataId": 30007, "name": "width", "value": "19.5", "type": "decimal" },
                                {
                                    "metaDataId": 30008,
                                    "name": "attachConfig",
                                    "value": "{\"parentTypes\":[\"mount-surface\"],\"anchorPointTypes\":[\"cleat\"],\"anchorPattern\": \"4x3\",\"maxFootPrintSpan\":2,\"offsets\":{\"top\":-2,\"left\":-1.1}}",
                                    "type": "string"
                                }
                            ],
                            "dependentOptions": [],
                            "dataType": "List"
                        }
                    ],
          sequence: 3,
          groupSequence: 3,
          tags: [],
          choiceGroups: []
        },
                        {
                    "isActive": true,
                    "isRequired": false,
                    "isHidden": false,
                    "isVisualized": false,
                    "isDependent": false,
                    "isIndexable": false,
                    "internalName": "WALL_PLATE_KITS",
                    "isInternalOnly": false,
                    "shortLabel": "KITS",
                    "longLabel": "KITS",
                    "optionType": null,
                    "description": "",
                    "id": 15578,
                    "presentationName": "KITS",
                    "choices": [
                        {
                            "id": 265392,
                            "mediaUrl": "https://blinds.homedepot.com/product-images/809b2d20-8c0e-f111-8491-0afffee37a07.png",
                            "media": {
                                "alternateText": "711698_265392_0",
                                "caption": null,
                                "mediaOwner": null
                            },
                            "isActive": true,
                            "internalName": "_32PC_RTCHTSCKT_WPKOUT_LP_COMP_ORG",
                            "shortLabel": "32PC RTCHT/SCKT W/PKOUT LP COMP ORG",
                            "longLabel": "32PC RTCHT/SCKT W/PKOUT LP COMP ORG",
                            "siteProductOptionChoiceShortLabel": null,
                            "siteProductOptionChoiceLongLabel": null,
                            "price": 0.0,
                            "sequence": 1,
                            "isSelected": false,
                            "isDefault": false,
                            "isBackordered": false,
                            "fillDate": null,
                            "value": null,
                            "minValue": 0.0,
                            "maxValue": 0.0,
                            "tags": [],
                            "fullPath": "WALL_PLATE_KITS",
                            "metaDataItems": [
                                {
                                    "metaDataId": 19255,
                                    "name": "attachConfig",
                                    "value": "{\"parentTypes\":[\"mount-surface\"],\"anchorPointTypes\":[\"cleat\"],\"anchorPattern\": \"2x3\",\"maxFootPrintSpan\":1,\"offsets\":{\"top\":-1.8,\"left\":-1.2}}",
                                    "type": "string"
                                },
                                {
                                    "metaDataId": 10811,
                                    "name": "Sku",
                                    "value": "313127913",
                                    "type": "string"
                                },
                                {
                                    "metaDataId": 19144,
                                    "name": "height",
                                    "value": "16.2",
                                    "type": "decimal"
                                },
                                {
                                    "metaDataId": 19145,
                                    "name": "width",
                                    "value": "9.8",
                                    "type": "decimal"
                                }
                            ],
                            "dependentOptions": [],
                            "dataType": "List"
                        },
                        {
                            "id": 265389,
                            "mediaUrl": "https://blinds.homedepot.com/product-images/94ceb302-8c0e-f111-8491-0afffee37a07.png",
                            "media": {
                                "alternateText": "711698_265389_0",
                                "caption": null,
                                "mediaOwner": null
                            },
                            "isActive": true,
                            "internalName": "_38_28PC_RTCHTSCKT_SET_IN_PKOUT",
                            "shortLabel": "3/8\" - 28PC RTCHT/SCKT SET IN PKOUT",
                            "longLabel": "3/8\" - 28PC RTCHT/SCKT SET IN PKOUT",
                            "siteProductOptionChoiceShortLabel": null,
                            "siteProductOptionChoiceLongLabel": null,
                            "price": 0.0,
                            "sequence": 1,
                            "isSelected": false,
                            "isDefault": false,
                            "isBackordered": false,
                            "fillDate": null,
                            "value": null,
                            "minValue": 0.0,
                            "maxValue": 0.0,
                            "tags": [],
                            "fullPath": "WALL_PLATE_KITS",
                            "metaDataItems": [
                                {
                                    "metaDataId": 10812,
                                    "name": "Sku",
                                    "value": "309586202",
                                    "type": "string"
                                },
                                {
                                    "metaDataId": 19138,
                                    "name": "height",
                                    "value": "16.2",
                                    "type": "decimal"
                                },
                                {
                                    "metaDataId": 19139,
                                    "name": "width",
                                    "value": "9.8",
                                    "type": "decimal"
                                },
                                {
                                    "metaDataId": 19258,
                                    "name": "attachConfig",
                                    "value": "{\"parentTypes\":[\"mount-surface\"],\"anchorPointTypes\":[\"cleat\"],\"anchorPattern\": \"2x3\",\"maxFootPrintSpan\":1,\"offsets\":{\"top\":-1.9,\"left\":-1.1}}",
                                    "type": "string"
                                }
                            ],
                            "dependentOptions": [],
                            "dataType": "List"
                        },
                        {
                            "id": 265395,
                            "mediaUrl": "https://blinds.homedepot.com/product-images/c19c2a45-8c0e-f111-8491-0afffee37a07.png",
                            "media": {
                                "alternateText": "711698_265395_0",
                                "caption": null,
                                "mediaOwner": null
                            },
                            "isActive": true,
                            "internalName": "_47PC_12_DR_RTCHTSCKT_SETPACKOUT",
                            "shortLabel": "47PC 1/2\" DR RTCHT/SCKT SET-PACKOUT",
                            "longLabel": "47PC 1/2\" DR RTCHT/SCKT SET-PACKOUT",
                            "siteProductOptionChoiceShortLabel": null,
                            "siteProductOptionChoiceLongLabel": null,
                            "price": 0.0,
                            "sequence": 1,
                            "isSelected": false,
                            "isDefault": false,
                            "isBackordered": false,
                            "fillDate": null,
                            "value": null,
                            "minValue": 0.0,
                            "maxValue": 0.0,
                            "tags": [],
                            "fullPath": "WALL_PLATE_KITS",
                            "metaDataItems": [
                                {
                                    "metaDataId": 10827,
                                    "name": "Sku",
                                    "value": "322405466",
                                    "type": "string"
                                },
                                {
                                    "metaDataId": 19150,
                                    "name": "height",
                                    "value": "16.3",
                                    "type": "decimal"
                                },
                                {
                                    "metaDataId": 19151,
                                    "name": "width",
                                    "value": "19.7",
                                    "type": "decimal"
                                },
                                {
                                    "metaDataId": 19252,
                                    "name": "attachConfig",
                                    "value": "{\"parentTypes\":[\"mount-surface\"],\"anchorPointTypes\":[\"cleat\"],\"anchorPattern\": \"4x3\",\"maxFootPrintSpan\":2,\"offsets\":{\"top\":-2,\"left\":-1.1}}",
                                    "type": "string"
                                }
                            ],
                            "dependentOptions": [],
                            "dataType": "List"
                        },
                        {
                            "id": 265388,
                            "mediaUrl": "https://blinds.homedepot.com/product-images/a35e968a-8c0e-f111-8491-0afffee37a07.png",
                            "media": {
                                "alternateText": "711698_265388_0",
                                "caption": null,
                                "mediaOwner": null
                            },
                            "isActive": true,
                            "internalName": "_CLSA_COMP_PACKOUT_FIRST_AID_KIT",
                            "shortLabel": "CLS-A COMP PACKOUT FIRST AID KIT",
                            "longLabel": "CLS-A COMP PACKOUT FIRST AID KIT",
                            "siteProductOptionChoiceShortLabel": null,
                            "siteProductOptionChoiceLongLabel": null,
                            "price": 0.0,
                            "sequence": 1,
                            "isSelected": false,
                            "isDefault": false,
                            "isBackordered": false,
                            "fillDate": null,
                            "value": null,
                            "minValue": 0.0,
                            "maxValue": 0.0,
                            "tags": [],
                            "fullPath": "WALL_PLATE_KITS",
                            "metaDataItems": [
                                {
                                    "metaDataId": 10813,
                                    "name": "Sku",
                                    "value": "321502928",
                                    "type": "string"
                                },
                                {
                                    "metaDataId": 19136,
                                    "name": "height",
                                    "value": "15.2",
                                    "type": "decimal"
                                },
                                {
                                    "metaDataId": 19137,
                                    "name": "width",
                                    "value": "9.8",
                                    "type": "decimal"
                                },
                                {
                                    "metaDataId": 19259,
                                    "name": "attachConfig",
                                    "value": "{\"parentTypes\":[\"mount-surface\"],\"anchorPointTypes\":[\"cleat\"],\"anchorPattern\": \"2x3\",\"maxFootPrintSpan\":1,\"offsets\":{\"top\":-2,\"left\":-1.2}}",
                                    "type": "string"
                                }
                            ],
                            "dependentOptions": [],
                            "dataType": "List"
                        },
                        {
                            "id": 265393,
                            "mediaUrl": "https://blinds.homedepot.com/product-images/9c25d862-8c0e-f111-8491-0afffee37a07.png",
                            "media": {
                                "alternateText": "711698_265393_0",
                                "caption": null,
                                "mediaOwner": null
                            },
                            "isActive": true,
                            "internalName": "_CLSB_PACKOUT_FIRST_AID_KIT",
                            "shortLabel": "CLS-B PACKOUT FIRST AID KIT",
                            "longLabel": "CLS-B PACKOUT FIRST AID KIT",
                            "siteProductOptionChoiceShortLabel": null,
                            "siteProductOptionChoiceLongLabel": null,
                            "price": 0.0,
                            "sequence": 1,
                            "isSelected": false,
                            "isDefault": false,
                            "isBackordered": false,
                            "fillDate": null,
                            "value": null,
                            "minValue": 0.0,
                            "maxValue": 0.0,
                            "tags": [],
                            "fullPath": "WALL_PLATE_KITS",
                            "metaDataItems": [
                                {
                                    "metaDataId": 10826,
                                    "name": "Sku",
                                    "value": "321502919",
                                    "type": "string"
                                },
                                {
                                    "metaDataId": 19146,
                                    "name": "height",
                                    "value": "15.2",
                                    "type": "decimal"
                                },
                                {
                                    "metaDataId": 19147,
                                    "name": "width",
                                    "value": "19.7",
                                    "type": "decimal"
                                },
                                {
                                    "metaDataId": 19254,
                                    "name": "attachConfig",
                                    "value": "{\"parentTypes\":[\"mount-surface\"],\"anchorPointTypes\":[\"cleat\"],\"anchorPattern\": \"4x3\",\"maxFootPrintSpan\":2,\"offsets\":{\"top\":-2,\"left\":-1.1}}",
                                    "type": "string"
                                }
                            ],
                            "dependentOptions": [],
                            "dataType": "List"
                        },
                        {
                            "id": 265396,
                            "mediaUrl": "https://blinds.homedepot.com/product-images/3730fd33-8c0e-f111-8491-0afffee37a07.png",
                            "media": {
                                "alternateText": "711698_265396_0",
                                "caption": null,
                                "mediaOwner": null
                            },
                            "isActive": true,
                            "internalName": "_106PC_RTCHTSCKT_WPKOUT_LP_ORG",
                            "shortLabel": "106PC RTCHT/SCKT W/PKOUT LP ORG",
                            "longLabel": "106PC RTCHT/SCKT W/PKOUT LP ORG",
                            "siteProductOptionChoiceShortLabel": null,
                            "siteProductOptionChoiceLongLabel": null,
                            "price": 0.0,
                            "sequence": 2,
                            "isSelected": false,
                            "isDefault": false,
                            "isBackordered": false,
                            "fillDate": null,
                            "value": null,
                            "minValue": 0.0,
                            "maxValue": 0.0,
                            "tags": [],
                            "fullPath": "WALL_PLATE_KITS",
                            "metaDataItems": [
                                {
                                    "metaDataId": 10810,
                                    "name": "Sku",
                                    "value": "313128236",
                                    "type": "string"
                                },
                                {
                                    "metaDataId": 19152,
                                    "name": "height",
                                    "value": "16.3",
                                    "type": "decimal"
                                },
                                {
                                    "metaDataId": 19153,
                                    "name": "width",
                                    "value": "19.7",
                                    "type": "decimal"
                                },
                                {
                                    "metaDataId": 19251,
                                    "name": "attachConfig",
                                    "value": "{\"parentTypes\":[\"mount-surface\"],\"anchorPointTypes\":[\"cleat\"],\"anchorPattern\": \"4x3\",\"maxFootPrintSpan\":2,\"offsets\":{\"top\":-1.8,\"left\":-1.3}}",
                                    "type": "string"
                                }
                            ],
                            "dependentOptions": [],
                            "dataType": "List"
                        },
                        {
                            "id": 265398,
                            "mediaUrl": "https://blinds.homedepot.com/product-images/4bd074d1-8c0e-f111-8491-0afffee37a07.png",
                            "media": {
                                "alternateText": "711698_265398_0",
                                "caption": null,
                                "mediaOwner": null
                            },
                            "isActive": true,
                            "internalName": "_12DR_15PC_SAE_PO_IMP_SCKT_SET",
                            "shortLabel": "1/2DR 15PC SAE PO IMP SCKT SET",
                            "longLabel": "1/2DR 15PC SAE PO IMP SCKT SET",
                            "siteProductOptionChoiceShortLabel": null,
                            "siteProductOptionChoiceLongLabel": null,
                            "price": 0.0,
                            "sequence": 4,
                            "isSelected": false,
                            "isDefault": false,
                            "isBackordered": false,
                            "fillDate": null,
                            "value": null,
                            "minValue": 0.0,
                            "maxValue": 0.0,
                            "tags": [],
                            "fullPath": "WALL_PLATE_KITS",
                            "metaDataItems": [
                                {
                                    "metaDataId": 10817,
                                    "name": "Sku",
                                    "value": "320203635",
                                    "type": "string"
                                },
                                {
                                    "metaDataId": 19156,
                                    "name": "height",
                                    "value": "15.2",
                                    "type": "decimal"
                                },
                                {
                                    "metaDataId": 19157,
                                    "name": "width",
                                    "value": "9.8",
                                    "type": "decimal"
                                },
                                {
                                    "metaDataId": 19249,
                                    "name": "attachConfig",
                                    "value": "{\"parentTypes\":[\"mount-surface\"],\"anchorPointTypes\":[\"cleat\"],\"anchorPattern\": \"2x3\",\"maxFootPrintSpan\":1,\"offsets\":{\"top\":-2,\"left\":-1}}",
                                    "type": "string"
                                }
                            ],
                            "dependentOptions": [],
                            "dataType": "List"
                        },
                        {
                            "id": 265399,
                            "mediaUrl": "https://blinds.homedepot.com/product-images/9313a3be-8c0e-f111-8491-0afffee37a07.png",
                            "media": {
                                "alternateText": "711698_265399_0",
                                "caption": null,
                                "mediaOwner": null
                            },
                            "isActive": true,
                            "internalName": "_38DR_19PC_MM_PO_IMP_SCKT_SET",
                            "shortLabel": "3/8DR 19PC MM PO IMP SCKT SET",
                            "longLabel": "3/8DR 19PC MM PO IMP SCKT SET",
                            "siteProductOptionChoiceShortLabel": null,
                            "siteProductOptionChoiceLongLabel": null,
                            "price": 0.0,
                            "sequence": 5,
                            "isSelected": false,
                            "isDefault": false,
                            "isBackordered": false,
                            "fillDate": null,
                            "value": null,
                            "minValue": 0.0,
                            "maxValue": 0.0,
                            "tags": [],
                            "fullPath": "WALL_PLATE_KITS",
                            "metaDataItems": [
                                {
                                    "metaDataId": 10831,
                                    "name": "Sku",
                                    "value": "320203602",
                                    "type": "string"
                                },
                                {
                                    "metaDataId": 19158,
                                    "name": "height",
                                    "value": "16.2",
                                    "type": "decimal"
                                },
                                {
                                    "metaDataId": 19159,
                                    "name": "width",
                                    "value": "9.8",
                                    "type": "decimal"
                                },
                                {
                                    "metaDataId": 19248,
                                    "name": "attachConfig",
                                    "value": "{\"parentTypes\":[\"mount-surface\"],\"anchorPointTypes\":[\"cleat\"],\"anchorPattern\": \"2x3\",\"maxFootPrintSpan\":1,\"offsets\":{\"top\":-2,\"left\":-1.1}}",
                                    "type": "string"
                                }
                            ],
                            "dependentOptions": [],
                            "dataType": "List"
                        },
                        {
                            "id": 265407,
                            "mediaUrl": "https://blinds.homedepot.com/product-images/23f2aeae-8c0e-f111-8491-0afffee37a07.png",
                            "media": {
                                "alternateText": "711698_265407_0",
                                "caption": null,
                                "mediaOwner": null
                            },
                            "isActive": true,
                            "internalName": "_38DR_17PC_SAE_PO_IMP_SCKT_SET",
                            "shortLabel": "3/8DR 17PC SAE PO IMP SCKT SET",
                            "longLabel": "3/8DR 17PC SAE PO IMP SCKT SET",
                            "siteProductOptionChoiceShortLabel": null,
                            "siteProductOptionChoiceLongLabel": null,
                            "price": 0.0,
                            "sequence": 7,
                            "isSelected": false,
                            "isDefault": false,
                            "isBackordered": false,
                            "fillDate": null,
                            "value": null,
                            "minValue": 0.0,
                            "maxValue": 0.0,
                            "tags": [],
                            "fullPath": "WALL_PLATE_KITS",
                            "metaDataItems": [
                                {
                                    "metaDataId": 10832,
                                    "name": "Sku",
                                    "value": "320203501",
                                    "type": "string"
                                },
                                {
                                    "metaDataId": 19162,
                                    "name": "height",
                                    "value": "16.2",
                                    "type": "decimal"
                                },
                                {
                                    "metaDataId": 19163,
                                    "name": "width",
                                    "value": "9.8",
                                    "type": "decimal"
                                },
                                {
                                    "metaDataId": 19246,
                                    "name": "attachConfig",
                                    "value": "{\"parentTypes\":[\"mount-surface\"],\"anchorPointTypes\":[\"cleat\"],\"anchorPattern\": \"2x3\",\"maxFootPrintSpan\":1,\"offsets\":{\"top\":-1.7,\"left\":-1.1}}",
                                    "type": "string"
                                }
                            ],
                            "dependentOptions": [],
                            "dataType": "List"
                        },
                        {
                            "id": 265415,
                            "mediaUrl": "https://blinds.homedepot.com/product-images/5eff76dd-8c0e-f111-8491-0afffee37a07.png",
                            "media": {
                                "alternateText": "711698_265415_0",
                                "caption": null,
                                "mediaOwner": null
                            },
                            "isActive": true,
                            "internalName": "_27PC_12_DRIVE_MMANDSAE_PACKOUT_SET",
                            "shortLabel": "27PC 1/2\" DRIVE MM&SAE PACKOUT SET",
                            "longLabel": "27PC 1/2\" DRIVE MM&SAE PACKOUT SET",
                            "siteProductOptionChoiceShortLabel": null,
                            "siteProductOptionChoiceLongLabel": null,
                            "price": 0.0,
                            "sequence": 8,
                            "isSelected": false,
                            "isDefault": false,
                            "isBackordered": false,
                            "fillDate": null,
                            "value": null,
                            "minValue": 0.0,
                            "maxValue": 0.0,
                            "tags": [],
                            "fullPath": "WALL_PLATE_KITS",
                            "metaDataItems": [
                                {
                                    "metaDataId": 10837,
                                    "name": "Sku",
                                    "value": "320204158",
                                    "type": "string"
                                },
                                {
                                    "metaDataId": 19164,
                                    "name": "height",
                                    "value": "15.2",
                                    "type": "decimal"
                                },
                                {
                                    "metaDataId": 19165,
                                    "name": "width",
                                    "value": "9.8",
                                    "type": "decimal"
                                },
                                {
                                    "metaDataId": 19245,
                                    "name": "attachConfig",
                                    "value": "{\"parentTypes\":[\"mount-surface\"],\"anchorPointTypes\":[\"cleat\"],\"anchorPattern\": \"2x3\",\"maxFootPrintSpan\":1,\"offsets\":{\"top\":-2,\"left\":-1.1}}",
                                    "type": "string"
                                }
                            ],
                            "dependentOptions": [],
                            "dataType": "List"
                        }
                    ],
                    "sequence": 4,
                    "groupSequence": 4,
                    "tags": [],
                    "choiceGroups": []
                },
        {
          isActive: true,
          isRequired: false,
          isHidden: false,
          isVisualized: false,
          isDependent: false,
          isIndexable: false,
          internalName: 'PACKOUTRackPopularBundles',
          isInternalOnly: false,
          shortLabel: 'Popular Bundles',
          longLabel: 'Looking for good place to start? Start building your system with popular PACKOUT bundles',
          optionType: null,
          description: '',
          id: 15490,
          presentationName: 'Racks',
          choices: [
            {
              id: 264791,
              mediaUrl: 'https://gcc-visualizer-images.s3.us-east-1.amazonaws.com/is/image/VehicleStorage/682010+-+Packout+Vehicle+Storage/712166_444444_1.png',
              media: {
                alternateText: '2 Rack Drawer High',
                caption: null,
                mediaOwner: null
              },
              isActive: true,
              internalName: 'RackDrawerHigh2',
              shortLabel: '2 Rack Drawer High',
              longLabel: null,
              siteProductOptionChoiceShortLabel: null,
              siteProductOptionChoiceLongLabel: null,
              price: 0.0,
              sequence: 1,
              isSelected: false,
              isDefault: false,
              isBackordered: false,
              fillDate: null,
              value: null,
              minValue: 0.0,
              maxValue: 0.0,
              tags: [],
              fullPath: 'PACKOUTRackPopularBundles',
              metaDataItems: [
                {
                  metaDataId: 10277,
                  name: 'Sku',
                  value: '337195391',
                  type: 'string'
                },
                {
                  metaDataId: 1028501,
                  name: 'isBase',
                  value: 'true',
                  type: 'string'
                },
                {
                  metaDataId: 1028502,
                  name: 'floorOnly',
                  value: 'true',
                  type: 'string'
                },
                {
                  metaDataId: 1028503,
                  name: 'width',
                  value: '27.30',
                  type: 'decimal'
                },
                {
                  metaDataId: 1028504,
                  name: 'height',
                  value: '63',
                  type: 'decimal'
                },
                {
                  metaDataId: 1028505,
                  name: 'dimensions',
                  value: '27.30x63',
                  type: 'string'
                }
              ],
              dependentOptions: [],
              dataType: 'List'
            },
            {
              id: 264792,
              mediaUrl: 'https://gcc-visualizer-images.s3.us-east-1.amazonaws.com/is/image/VehicleStorage/682010+-+Packout+Vehicle+Storage/712166_333333_1.png',
              media: {
                alternateText: '2 Rack Drawer Mid',
                caption: null,
                mediaOwner: null
              },
              isActive: true,
              internalName: 'RackDrawerMid2',
              shortLabel: '2 Rack Drawer Mid',
              longLabel: null,
              siteProductOptionChoiceShortLabel: null,
              siteProductOptionChoiceLongLabel: null,
              price: 0.0,
              sequence: 2,
              isSelected: false,
              isDefault: false,
              isBackordered: false,
              fillDate: null,
              value: null,
              minValue: 0.0,
              maxValue: 0.0,
              tags: [],
              fullPath: 'PACKOUTRackPopularBundles',
              metaDataItems: [
                {
                  metaDataId: 10278,
                  name: 'Sku',
                  value: '337195397',
                  type: 'string'
                },
                {
                  metaDataId: 1028601,
                  name: 'isBase',
                  value: 'true',
                  type: 'string'
                },
                {
                  metaDataId: 1028602,
                  name: 'floorOnly',
                  value: 'true',
                  type: 'string'
                },
                {
                  metaDataId: 1028603,
                  name: 'width',
                  value: '27.30',
                  type: 'decimal'
                },
                {
                  metaDataId: 1028604,
                  name: 'height',
                  value: '44.95',
                  type: 'decimal'
                },
                {
                  metaDataId: 1028605,
                  name: 'dimensions',
                  value: '27.30x44.95',
                  type: 'string'
                }
              ],
              dependentOptions: [],
              dataType: 'List'
            },
            {
              id: 264793,
              mediaUrl: 'https://gcc-visualizer-images.s3.us-east-1.amazonaws.com/is/image/VehicleStorage/682010+-+Packout+Vehicle+Storage/712166_222222_1.png',
              media: {
                alternateText: '1 Rack Drawer Low',
                caption: null,
                mediaOwner: null
              },
              isActive: true,
              internalName: 'RackDrawerLow1',
              shortLabel: '1 Rack Drawer Low',
              longLabel: null,
              siteProductOptionChoiceShortLabel: null,
              siteProductOptionChoiceLongLabel: null,
              price: 0.0,
              sequence: 3,
              isSelected: false,
              isDefault: false,
              isBackordered: false,
              fillDate: null,
              value: null,
              minValue: 0.0,
              maxValue: 0.0,
              tags: [],
              fullPath: 'PACKOUTRackPopularBundles',
              metaDataItems: [
                {
                  metaDataId: 10279,
                  name: 'Sku',
                  value: '337195406',
                  type: 'string'
                },
                {
                  metaDataId: 1028701,
                  name: 'isBase',
                  value: 'true',
                  type: 'string'
                },
                {
                  metaDataId: 1028702,
                  name: 'floorOnly',
                  value: 'true',
                  type: 'string'
                },
                {
                  metaDataId: 1028703,
                  name: 'width',
                  value: '27.30',
                  type: 'decimal'
                },
                {
                  metaDataId: 1028704,
                  name: 'height',
                  value: '35.95',
                  type: 'decimal'
                },
                {
                  metaDataId: 1028705,
                  name: 'dimensions',
                  value: '27.30x35.95',
                  type: 'string'
                }
              ],
              dependentOptions: [],
              dataType: 'List'
            },
            {
              id: 264794,
              mediaUrl: 'https://gcc-visualizer-images.s3.us-east-1.amazonaws.com/is/image/VehicleStorage/682010+-+Packout+Vehicle+Storage/712166_111111_1.png',
              media: {
                alternateText: '1 Rack Drawer High',
                caption: null,
                mediaOwner: null
              },
              isActive: true,
              internalName: 'RackDrawerHigh1',
              shortLabel: '1 Rack Drawer High',
              longLabel: null,
              siteProductOptionChoiceShortLabel: null,
              siteProductOptionChoiceLongLabel: null,
              price: 0.0,
              sequence: 4,
              isSelected: false,
              isDefault: false,
              isBackordered: false,
              fillDate: null,
              value: null,
              minValue: 0.0,
              maxValue: 0.0,
              tags: [],
              fullPath: 'PACKOUTRackPopularBundles',
              metaDataItems: [
                {
                  metaDataId: 10280,
                  name: 'Sku',
                  value: '337195423',
                  type: 'string'
                },
                {
                  metaDataId: 1028801,
                  name: 'isBase',
                  value: 'true',
                  type: 'string'
                },
                {
                  metaDataId: 1028802,
                  name: 'floorOnly',
                  value: 'true',
                  type: 'string'
                },
                {
                  metaDataId: 1028803,
                  name: 'width',
                  value: '27.30',
                  type: 'decimal'
                },
                {
                  metaDataId: 1028804,
                  name: 'height',
                  value: '55.95',
                  type: 'decimal'
                },
                {
                  metaDataId: 1028805,
                  name: 'dimensions',
                  value: '27.30x55.95',
                  type: 'string'
                }
              ],
              dependentOptions: [],
              dataType: 'List'
            }
          ],
          sequence: 4,
          groupSequence: 4,
          tags: [],
          choiceGroups: []
        },
        {
          isActive: true,
          isRequired: false,
          isHidden: false,
          isVisualized: false,
          isDependent: false,
          isIndexable: false,
          internalName: 'CABINET_BASE_CABINETS',
          isInternalOnly: false,
          shortLabel: 'BASE CABINETS',
          longLabel: 'BASE CABINETS',
          optionType: null,
          description: '',
          id: 19001,
          presentationName: 'BASE CABINETS',
          choices: [
            {
              id: 270001,
              mediaUrl: 'https://blinds.homedepot.com/is/image/cabinets/248906/328272163.png',
              media: {
                alternateText: 'Base Cabinet',
                caption: null,
                mediaOwner: null
              },
              isActive: true,
              internalName: '_BASE_CABINET_36W',
              shortLabel: 'BASE CABINET 36W',
              longLabel: 'BASE CABINET 36W',
              siteProductOptionChoiceShortLabel: null,
              siteProductOptionChoiceLongLabel: null,
              price: 0.0,
              sequence: 1,
              isSelected: false,
              isDefault: false,
              isBackordered: false,
              fillDate: null,
              value: null,
              minValue: 0.0,
              maxValue: 0.0,
              tags: [],
              fullPath: 'CABINET_BASE_CABINETS',
              metaDataItems: [
                {
                  metaDataId: 29001,
                  name: 'Sku',
                  value: '326492802',
                  type: 'string'
                },
                {
                  metaDataId: 29002,
                  name: 'isBase',
                  value: 'true',
                  type: 'string'
                },
                {
                  metaDataId: 29003,
                  name: 'width',
                  value: '36',
                  type: 'decimal'
                },
                {
                  metaDataId: 29004,
                  name: 'height',
                  value: '34.5',
                  type: 'decimal'
                },
                {
                  metaDataId: 29005,
                  name: 'dimensions',
                  value: '36x34.5',
                  type: 'string'
                },
                {
                  metaDataId: 29006,
                  name: 'floorOnly',
                  value: 'true',
                  type: 'string'
                }
              ],
              dependentOptions: [],
              dataType: 'List'
            }
          ],
          sequence: 5,
          groupSequence: 5,
          tags: [],
          choiceGroups: []
        },
        {
          isActive: true,
          isRequired: false,
          isHidden: false,
          isVisualized: false,
          isDependent: false,
          isIndexable: false,
          internalName: 'CABINET_WALL_CABINETS',
          isInternalOnly: false,
          shortLabel: 'WALL CABINETS',
          longLabel: 'WALL CABINETS',
          optionType: null,
          description: '',
          id: 19002,
          presentationName: 'WALL CABINETS',
          choices: [
            {
              id: 270002,
              mediaUrl: 'https://blinds.homedepot.com/is/image/cabinets/248906/328272755.png',
              media: {
                alternateText: 'Wall Cabinet 36W',
                caption: null,
                mediaOwner: null
              },
              isActive: true,
              internalName: '_WALL_CABINET_36W',
              shortLabel: 'WALL CABINET 36W',
              longLabel: 'WALL CABINET 36W',
              siteProductOptionChoiceShortLabel: null,
              siteProductOptionChoiceLongLabel: null,
              price: 0.0,
              sequence: 1,
              isSelected: false,
              isDefault: false,
              isBackordered: false,
              fillDate: null,
              value: null,
              minValue: 0.0,
              maxValue: 0.0,
              tags: [],
              fullPath: 'CABINET_WALL_CABINETS',
              metaDataItems: [
                {
                  metaDataId: 29003,
                  name: 'Sku',
                  value: '328272755',
                  type: 'string'
                },
                {
                  metaDataId: 29004,
                  name: 'isBase',
                  value: 'true',
                  type: 'string'
                },
                {
                  metaDataId: 29007,
                  name: 'width',
                  value: '36',
                  type: 'decimal'
                },
                {
                  metaDataId: 29008,
                  name: 'height',
                  value: '42',
                  type: 'decimal'
                },
                {
                  metaDataId: 29009,
                  name: 'dimensions',
                  value: '36x42',
                  type: 'string'
                },
                {
                  metaDataId: 29016,
                  name: 'componentType',
                  value: 'wall-cabinet',
                  type: 'string'
                }
              ],
              dependentOptions: [],
              dataType: 'List'
            }
          ],
          sequence: 6,
          groupSequence: 6,
          tags: [],
          choiceGroups: []
        },
        {
          isActive: true,
          isRequired: false,
          isHidden: false,
          isVisualized: false,
          isDependent: false,
          isIndexable: false,
          internalName: 'CABINET_TALL_CABINETS',
          isInternalOnly: false,
          shortLabel: 'TALL CABINETS',
          longLabel: 'TALL CABINETS',
          optionType: null,
          description: '',
          id: 19003,
          presentationName: 'TALL CABINETS',
          choices: [
            {
              id: 270003,
              mediaUrl: 'https://blinds.homedepot.com/is/image/cabinets/248906/328272477.png',
              media: {
                alternateText: 'Tall Cabinet',
                caption: null,
                mediaOwner: null
              },
              isActive: true,
              internalName: '_TALL_CABINET_18W',
              shortLabel: 'TALL CABINET 18W',
              longLabel: 'TALL CABINET 18W',
              siteProductOptionChoiceShortLabel: null,
              siteProductOptionChoiceLongLabel: null,
              price: 0.0,
              sequence: 1,
              isSelected: false,
              isDefault: false,
              isBackordered: false,
              fillDate: null,
              value: null,
              minValue: 0.0,
              maxValue: 0.0,
              tags: [],
              fullPath: 'CABINET_TALL_CABINETS',
              metaDataItems: [
                {
                  metaDataId: 29010,
                  name: 'Sku',
                  value: '325948323',
                  type: 'string'
                },
                {
                  metaDataId: 29011,
                  name: 'isBase',
                  value: 'true',
                  type: 'string'
                },
                {
                  metaDataId: 29012,
                  name: 'width',
                  value: '30',
                  type: 'decimal'
                },
                {
                  metaDataId: 29013,
                  name: 'height',
                  value: '96',
                  type: 'decimal'
                },
                {
                  metaDataId: 29014,
                  name: 'dimensions',
                  value: '36x96',
                  type: 'string'
                },
                {
                  metaDataId: 29015,
                  name: 'floorOnly',
                  value: 'true',
                  type: 'string'
                }
              ],
              dependentOptions: [],
              dataType: 'List'
            }
          ],
          sequence: 7,
          groupSequence: 7,
          tags: [],
          choiceGroups: []
        }
      ]
    }
  ],
  visualizedOptions: [],
  choiceValueRanges: null,
  isVisualized: false,
  additionalDetails: null
};


export const mockRyobiConfiguratorData = {
  brand: 'Ryobi',
  productName: 'Wall Link Builder',
  siteProductName: 'Wall Link Builder',
  categoryLabel: 'Barn Doors',
  mainImageUrl: 'https://blinds.homedepot.com/product-images/d91edcca-9661-ec11-949a-0a986990730e.jpg',
  productType: 'Portable Storage',
  productId: 737244,
  variantId: 0,
  partnerProductId: 344131957,
  groups: [
    {
      name: 'Ungrouped',
      sequenceNumber: 0,
      options: [


        // ── Mock: Wall Rails option group (Ryobi wall rail system) ─────────────────
        // PLACEHOLDER SCAFFOLD — choice ids, SKUs, image URLs, and dimensions below
        // are all TODO_* placeholders pending real metadata for "Wall Rail",
        // "End Cap - Left", and "End Cap - Right" (product 344131957, option
        // "Wall Rails"). Replace every TODO_* value once the real data is provided.
        {
          isActive: true,
          isRequired: false,
          isHidden: false,
          isVisualized: false,
          isDependent: false,
          isIndexable: false,
          internalName: 'WALL_RAILS',
          isInternalOnly: false,
          shortLabel: 'WALL RAILS',
          longLabel: 'WALL RAILS',
          optionType: null,
          description: '',
          id: 17962,
          presentationName: 'WALL RAILS',
          choices: [
            {
              id: 284417,
              mediaUrl: 'https://blinds.homedepot.com/is/image/blinds/737244_284417_0?fmt=png',
              media: { alternateText: 'Wall Rail', caption: null, mediaOwner: null },
              isActive: true,
              internalName: '_RYOBI_WALL_RAIL',
              shortLabel: 'Wall Rail',
              longLabel: 'RYOBI Wall Rail',
              siteProductOptionChoiceShortLabel: null,
              siteProductOptionChoiceLongLabel: null,
              price: 0.0,
              sequence: 1,
              isSelected: false,
              isDefault: false,
              isBackordered: false,
              fillDate: null,
              value: null,
              minValue: 0.0,
              maxValue: 0.0,
              tags: [],
              fullPath: 'WALL_RAILS',
              "metaDataItems": [
                  {
                      "metaDataId": 10830,
                      "name": "Sku",
                      "value": "342752715",
                      "type": "string"
                  },
                  {
                      "metaDataId": 19993,
                      "name": "soldAsBundleOnly",
                      "value": "true",
                      "type": "string"
                  },
                  {
                      "metaDataId": 18568,
                      "name": "isBase",
                      "value": "true",
                      "type": "string"
                  },
                  {
                      "metaDataId": 18642,
                      "name": "height",
                      "value": "4.8",
                      "type": "decimal"
                  },
                  {
                      // 2 x width - rail-to-rail overlap (1.42) must equal the 33.5in 2-pack bundle total
                      "metaDataId": 18643,
                      "name": "width",
                      "value": "17.46",
                      "type": "decimal"
                  },
                  {
                      "metaDataId": 186541,
                      "name": "anchorPointConfig.type",
                      "value": "slot",
                      "type": "string"
                  },
                  {
                      "metaDataId": 186543,
                      "name": "anchorPointConfig.anchorPointTypes",
                      "value": "[\"octagon\",\"slot\"]",
                      "type": "string"
                  },
                  {
                      "metaDataId": 20835,
                      "name": "anchorPointConfig.attachVariantPerspectives",
                      "value": "{\"octagon\":0,\"slot\":0}",
                      "type": "string"
                  },
                  {
                      "metaDataId": 1865401,
                      "name": "anchorPointConfig.offsets",
                      "value": '{"octagon": {"top": -1.5}}',
                      "type": "string"
                  },
                  {
                      // step derived so anchor c6 lands exactly on the next rail's c0:
                      // (width 17.46 - overlap 1.42) / 6 = 2.673333
                      "metaDataId": 186542,
                      "name": "anchorPointConfig.anchorPointSettings",
                      "value": '{"count":7,"row":0,"startColumn":0,"startLeft":-0.65,"top":0,"width":2.5,"height":3.8,"step":2.673333,"typeSequence":["slot","octagon"],"requiresAdjoiningRightColumn":6,"requiresAdjoiningLeftColumn":0}',
                      "type": "string"
                    },
                    {
                      "metaDataId": 186549,
                      "name": "anchorpointBuildPattern",
                      "value": {
                          "type": "explicit"
                      },
                      "type": "string"
                  },
                  {
                      "metaDataId": 18752,
                      "name": "componentType",
                      "value": "wall-rail",
                      "type": "string"
                  },
                  {
                      // rail-to-rail and rail-to-endcap both overlap 1.42
                      "metaDataId": 189464,
                      "name": "snapBehavior",
                      "value": '{"attachable":{"left":true,"right":true},"overlap":{"left":1.42,"right":1.42}}',
                      "type": "string"
                  }

              ],
              dependentOptions: [],
              dataType: 'List'
            },
            {
              id: 284418,
              mediaUrl: 'https://blinds.homedepot.com/is/image/blinds/737244_284418_0?fmt=png',
              media: { alternateText: 'End Cap - Left', caption: null, mediaOwner: null },
              isActive: true,
              internalName: '_RYOBI_WALL_RAIL_ENDCAP_LEFT',
              shortLabel: 'End Cap - Left',
              longLabel: 'RYOBI Wall Rail End Cap - Left',
              siteProductOptionChoiceShortLabel: null,
              siteProductOptionChoiceLongLabel: null,
              price: 0.0,
              sequence: 2,
              isSelected: false,
              isDefault: false,
              isBackordered: false,
              fillDate: null,
              value: null,
              minValue: 0.0,
              maxValue: 0.0,
              tags: [],
              fullPath: 'WALL_RAILS',
              "metaDataItems": [
                  {
                      "metaDataId": 10830,
                      "name": "Sku",
                      "value": "341827278",
                      "type": "string"
                  },
                  {
                      "metaDataId": 19992,
                      "name": "soldAsBundleOnly",
                      "value": "true",
                      "type": "string"
                  },
                  {
                      "metaDataId": 18568,
                      "name": "isBase",
                      "value": "true",
                      "type": "string"
                  },
                  {
                      "metaDataId": 18642,
                      "name": "height",
                      "value": "4.8",
                      "type": "decimal"
                  },
                  {
                      "metaDataId": 18643,
                      "name": "width",
                      "value": "3.72",
                      "type": "decimal"
                  },
                  {
                      "metaDataId": 186541,
                      "name": "anchorPointConfig.type",
                      "value": "slot",
                      "type": "string"
                  },
                  {
                      "metaDataId": 186540,
                      "name": "anchorPointConfig.attachVariantPerspectives",
                      "value": "{\"slot\":0}",
                      "type": "string"
                  },
                  {
                      "metaDataId": 186542,
                      "name": "anchorPointConfig.anchors[0]",
                      "value": '{"id":"ap-fp0-r0-c1","column":1,"left":1.67,"top":0,"width":2.5,"height":3.8,"type":"slot","requiresAdjoiningRight":true}',
                      "type": "string"
                  },
                  {
                      "metaDataId": 18655,
                      "name": "anchorpointBuildPattern",
                      "value": {
                          "type": "explicit"
                      },
                      "type": "json"
                  },
                  {
                      "metaDataId": 18752,
                      "name": "componentType",
                      "value": "wall-rail",
                      "type": "string"
                  },
                  {
                      "metaDataId": 189463,
                      "name": "snapBehavior",
                      "value": '{"attachable":{"left":false,"right":true},"overlap":{"right":1.42,"left":0}}',
                      "type": "string"
                  },
                  {
                      "metaDataId": 189464,
                      "name": "incompatibleAlertEligible",
                      "value": "true",
                      "type": "string"
                  }
              ],
              dependentOptions: [],
              dataType: 'List'
            },
            {
              id: 284419,
              mediaUrl: 'https://blinds.homedepot.com/is/image/blinds/737244_284419_0?fmt=png',
              media: { alternateText: 'End Cap - Right', caption: null, mediaOwner: null },
              isActive: true,
              internalName: '_RYOBI_WALL_RAIL_ENDCAP_RIGHT',
              shortLabel: 'End Cap - Right',
              longLabel: 'RYOBI Wall Rail End Cap - Right',
              siteProductOptionChoiceShortLabel: null,
              siteProductOptionChoiceLongLabel: null,
              price: 0.0,
              sequence: 3,
              isSelected: false,
              isDefault: false,
              isBackordered: false,
              fillDate: null,
              value: null,
              minValue: 0.0,
              maxValue: 0.0,
              tags: [],
              fullPath: 'WALL_RAILS',
              "metaDataItems": [
                      {
                          "metaDataId": 10830,
                          "name": "Sku",
                          "value": "341827278",
                          "type": "string"
                      },
                      {
                          "metaDataId": 19991,
                          "name": "soldAsBundleOnly",
                          "value": "true",
                          "type": "string"
                      },
                      {
                          "metaDataId": 18568,
                          "name": "isBase",
                          "value": "true",
                          "type": "string"
                      },
                      {
                          "metaDataId": 18642,
                          "name": "height",
                          "value": "4.8",
                          "type": "decimal"
                      },
                      {
                          "metaDataId": 18643,
                          "name": "width",
                          "value": "3.72",
                          "type": "decimal"
                      },
                      {
                          "metaDataId": 186541,
                          "name": "anchorPointConfig.type",
                           "value": "slot",
                          "type": "string"
                      },
                      {
                          "metaDataId": 186540,
                          "name": "anchorPointConfig.attachVariantPerspectives",
                          "value": "{\"slot\":0}",
                          "type": "string"
                      },
                      {
                          "metaDataId": 186542,
                          "name": "anchorPointConfig.anchors[0]",
                           "value": '{"id":"ap-fp0-r0-c0","column":0,"left":-0.65,"top":0,"width":2.5,"height":3.8,"type":"slot","requiresAdjoiningLeft":true}',
                          "type": "string"
                      },
                      {
                          "metaDataId": 18655,
                          "name": "anchorpointBuildPattern",
                          "value": {
                              "type": "explicit"
                          },
                          "type": "json"
                      },
                      {
                          "metaDataId": 18752,
                          "name": "componentType",
                          "value": "wall-rail",
                          "type": "string"
                      },
                      {
                          "metaDataId": 189463,
                          "name": "snapBehavior",
                          "value": {"attachable":{"left":true,"right":false},"overlap":{"left":1.42,"right":0}},
                          "type": "string"
                      },
                      {
                          "metaDataId": 189465,
                          "name": "incompatibleAlertEligible",
                          "value": "true",
                          "type": "string"
                      }
                  ],
              dependentOptions: [],
              dataType: 'List'
            },

            // ── Mock: Ryobi single-SKU bundle — two Wall Rails as one packaged SKU ──
            // Design ID maps to mock-data/bundle-designs/ryobi-wallRail-bundle.mock.js
            // Design-level Sku marks it as one packaged unit split into 2 independent
            // Wall Rail images grouped via a placement-time bundleInstanceId.
            {
              id: 280006,
              mediaUrl: 'https://images.thdstatic.com/productImages/e7054097-5288-473e-916a-4bbd741e9421/svn/ryobi-modular-tool-storage-systems-stm504-64_100.jpg',
              media: { alternateText: 'Ryobi Wall Rail 2-Pack Bundle', caption: null, mediaOwner: null },
              isActive: true,
              internalName: 'MOCK_SINGLE_SKU_BUNDLE_RYOBI_WALL_RAIL',
              shortLabel: 'Wall Rail 2-Pack (mock)',
              longLabel: 'RYOBI Wall Rail 2-Pack (Single-SKU Bundle)',
              siteProductOptionChoiceShortLabel: null,
              siteProductOptionChoiceLongLabel: null,
              price: 0.0,
              sequence: 4,
              isSelected: false,
              isDefault: false,
              isBackordered: false,
              fillDate: null,
              value: null,
              minValue: 0.0,
              maxValue: 0.0,
              tags: [],
              fullPath: 'WALL_RAILS',
              metaDataItems: [
                { metaDataId: 50031, name: 'isBase', value: 'true', type: 'string' },
                { metaDataId: 50032, name: 'BundleDesign', value: '8f0af0eb-0000-0000-0000-mock00000006', type: 'string' },
              ],
              dependentOptions: [],
              dataType: 'List'
            },

            // ── Mock: Ryobi single-SKU bundle — End Cap-Left + Wall Rail + End Cap-Right ──
            // Design ID maps to mock-data/bundle-designs/ryobi-wallRail-with-endcaps-bundle.mock.js
            // Design-level Sku marks it as one packaged unit split into 3 independent
            // part-images (slightly overlapping to interlock) grouped via a
            // placement-time bundleInstanceId.
            {
              id: 280007,
              mediaUrl: 'https://blinds.homedepot.com/product-images/5838f2bc-ce89-f111-8494-0afffee37a07.png',
              media: { alternateText: 'Ryobi Wall Rail + End Caps Bundle', caption: null, mediaOwner: null },
              isActive: true,
              internalName: 'MOCK_SINGLE_SKU_BUNDLE_RYOBI_WALL_RAIL_ENDCAPS',
              shortLabel: 'Wall Rail + End Caps (mock)',
              longLabel: 'RYOBI Wall Rail + End Caps (Single-SKU Bundle)',
              siteProductOptionChoiceShortLabel: null,
              siteProductOptionChoiceLongLabel: null,
              price: 0.0,
              sequence: 5,
              isSelected: false,
              isDefault: false,
              isBackordered: false,
              fillDate: null,
              value: null,
              minValue: 0.0,
              maxValue: 0.0,
              tags: [],
              fullPath: 'WALL_RAILS',
              metaDataItems: [
                { metaDataId: 50041, name: 'isBase', value: 'true', type: 'string' },
                { metaDataId: 50042, name: 'BundleDesign', value: '8f0af0eb-0000-0000-0000-mock00000007', type: 'string' },
              ],
              dependentOptions: [],
              dataType: 'List'
            },
            {
              id: 280008,
              "mediaUrl": "https://blinds.homedepot.com/product-images/8f0d7966-ca89-f111-8494-0afffee37a07.png",
              "media": { "alternateText": "Ryobi 2-End-Caps Pair Bundle", "caption": null, "mediaOwner": null },
              "isActive": true,
              "internalName": "MOCK_WALL_ENDCAPS_PAIR_BUNDLE",
              "shortLabel": "LINK 2-in-1 Endcaps",
              "longLabel": "Ryobi LINK 2-in-1 Endcaps",
              siteProductOptionChoiceShortLabel: null,
              siteProductOptionChoiceLongLabel: null,
              price: 0.0,
              sequence: 5,
              isSelected: false,
              isDefault: false,
              isBackordered: false,
              fillDate: null,
              value: null,
              minValue: 0.0,
              maxValue: 0.0,
              tags: [],
              fullPath: 'WALL_RAILS',
              metaDataItems: [
                { metaDataId: 50041, name: 'isBase', value: 'true', type: 'string' },
                { metaDataId: 50042, name: 'BundleDesign', value: '8f0af0eb-0000-0000-0000-mock00000008', type: 'string' },
              ],
              dependentOptions: [],
              dataType: 'List'
            },

          ],
          sequence: 0,
          groupSequence: 0,
          tags: [],
          choiceGroups: []
        },
                {
          isActive: true,
          isRequired: false,
          isHidden: false,
          isVisualized: false,
          isDependent: false,
          isIndexable: false,
          internalName: 'RYOBI_SKUS',
          isInternalOnly: false,
          shortLabel: 'HOOKS, SHELFS and CABINETS',
          longLabel: 'Hooks, Shelfs and Cabinets',
          optionType: null,
          description: '',
          id: 15585,
          presentationName: 'Hooks, Shelfs and Cabinets',
                    "choices": [
                       {
                            "id": 284304,
                            "mediaUrl": "https://blinds.homedepot.com/product-images/ca5ee52e-64a5-f111-8496-0afffee37a07.png",
                            "media": {
                                "alternateText": "Open Tool Organizer Cabinet",
                                "caption": null,
                                "mediaOwner": null
                            },
                            "isActive": true,
                            "internalName": "Open_Tool_Organizer_Cabinet",
                            "shortLabel": "Open Tool Organizer Cabinet",
                            "longLabel": "Open Tool Organizer Cabinet",
                            "siteProductOptionChoiceShortLabel": null,
                            "siteProductOptionChoiceLongLabel": null,
                            "price": 0.0,
                            "sequence": 2,
                            "isSelected": false,
                            "isDefault": false,
                            "isBackordered": false,
                            "fillDate": null,
                            "value": null,
                            "minValue": 0.0,
                            "maxValue": 0.0,
                            "tags": [],
                            "fullPath": "LINK_WALL_PLATE_CABINET",
                            "metaDataItems": [
                                {
                                    "metaDataId": 21258,
                                    "name": "width",
                                    "value": "21",
                                    "type": "decimal"
                                },
                                {
                                    "metaDataId": 21259,
                                    "name": "Sku",
                                    "value": "327993978",
                                    "type": "string"
                                },
                                {
                                    "metaDataId": 21260,
                                    "name": "attachConfig.parentTypes",
                                    "value": "[\"wall-rail\"]",
                                    "type": "string"
                                },
                                {
                                    "metaDataId": 21263,
                                    "name": "height",
                                    "value": "17.1",
                                    "type": "decimal"
                                },
                                {
                                    "metaDataId": 21265,
                                    "name": "attachConfig.startAnchorPointType",
                                    "value": "octagon",
                                    "type": "string"
                                },
                                {
                                    "metaDataId": 21266,
                                    "name": "attachConfig.maxFootPrintSpan",
                                    "value": "3",
                                    "type": "string"
                                },
                                {
                                    "metaDataId": 21267,
                                    "name": "attachConfig.anchorPattern",
                                    "value": "8x1",
                                    "type": "string"
                                },
                                {
                                    "metaDataId": 21304,
                                    "name": "attachConfig.attachOffsets",
                                    "value": "{\"octagon\":{\"top\":-1.5,\"left\":-1},\"slot\":{\"top\":-1.15,\"left\":-0.4}}",
                                    "type": "string"
                                }
                            ],
                            "dependentOptions": [],
                            "dataType": "List"
                        },
                       {
                            "id": 284305,
                            "mediaUrl": "https://blinds.homedepot.com/product-images/233a093f-64a5-f111-8496-0afffee37a07.png",
                            "media": {
                                "alternateText": "Wall Mounted Cabinet",
                                "caption": null,
                                "mediaOwner": null
                            },
                            "isActive": true,
                            "internalName": "Wall_Mounted_Cabinet",
                            "shortLabel": "Wall Mounted Cabinet",
                            "longLabel": "Wall Mounted Cabinet",
                            "siteProductOptionChoiceShortLabel": null,
                            "siteProductOptionChoiceLongLabel": null,
                            "price": 0.0,
                            "sequence": 3,
                            "isSelected": false,
                            "isDefault": false,
                            "isBackordered": false,
                            "fillDate": null,
                            "value": null,
                            "minValue": 0.0,
                            "maxValue": 0.0,
                            "tags": [],
                            "fullPath": "LINK_WALL_PLATE_CABINET",
                            "metaDataItems": [
                                {
                                    "metaDataId": 20876,
                                    "name": "Sku",
                                    "value": "323151826",
                                    "type": "string"
                                },
                                {
                                    "metaDataId": 20877,
                                    "name": "attachConfig.parentTypes",
                                    "value": "[\"wall-rail\"]",
                                    "type": "string"
                                },
                                {
                                    "metaDataId": 20878,
                                    "name": "attachConfig.maxFootPrintSpan",
                                    "value": "3",
                                    "type": "string"
                                },
                                {
                                    "metaDataId": 20879,
                                    "name": "attachConfig.anchorPattern",
                                    "value": "10x1",
                                    "type": "string"
                                },
                                {
                                    "metaDataId": 20880,
                                    "name": "height",
                                    "value": "25",
                                    "type": "decimal"
                                },
                                {
                                    "metaDataId": 20881,
                                    "name": "width",
                                    "value": "26.8",
                                    "type": "decimal"
                                },
                                {
                                    "metaDataId": 21246,
                                    "name": "attachConfig.startAnchorPointType",
                                    "value": "octagon",
                                    "type": "string"
                                },
                                {
                                    "metaDataId": 21440,
                                    "name": "attachConfig.attachOffsets",
                                    "value": "{\"octagon\":{\"top\":-1.5,\"left\":-0.7},\"slot\":{\"top\":-1.15,\"left\":-0.4}}",
                                    "type": "string"
                                }
                            ],
                            "dependentOptions": [],
                            "dataType": "List"
                        },
                      {
                            "id": 284303,
                            "mediaUrl": "https://blinds.homedepot.com/product-images/4a028a14-64a5-f111-8496-0afffee37a07.png",
                            "media": {
                                "alternateText": "Lockable Tool Organizer Cabinet",
                                "caption": null,
                                "mediaOwner": null
                            },
                            "isActive": true,
                            "internalName": "Lockable_Tool_Organizer_Cabinet",
                            "shortLabel": "Lockable Tool Organizer Cabinet",
                            "longLabel": "Lockable Tool Organizer Cabinet",
                            "siteProductOptionChoiceShortLabel": null,
                            "siteProductOptionChoiceLongLabel": null,
                            "price": 0.0,
                            "sequence": 1,
                            "isSelected": false,
                            "isDefault": false,
                            "isBackordered": false,
                            "fillDate": null,
                            "value": null,
                            "minValue": 0.0,
                            "maxValue": 0.0,
                            "tags": [],
                            "fullPath": "LINK_WALL_PLATE_CABINET",
                            "metaDataItems": [
                                {
                                    "metaDataId": 21247,
                                    "name": "width",
                                    "value": "21",
                                    "type": "decimal"
                                },
                                {
                                    "metaDataId": 21248,
                                    "name": "Sku",
                                    "value": "327994078",
                                    "type": "string"
                                },
                                {
                                    "metaDataId": 21249,
                                    "name": "attachConfig.parentTypes",
                                    "value": "[\"wall-rail\"]",
                                    "type": "string"
                                },
                                {
                                    "metaDataId": 21252,
                                    "name": "height",
                                    "value": "17.1",
                                    "type": "decimal"
                                },
                                {
                                    "metaDataId": 21254,
                                    "name": "attachConfig.startAnchorPointType",
                                    "value": "slot",
                                    "type": "string"
                                },
                                {
                                    "metaDataId": 21255,
                                    "name": "attachConfig.maxFootPrintSpan",
                                    "value": "3",
                                    "type": "string"
                                },
                                {
                                    "metaDataId": 21256,
                                    "name": "attachConfig.anchorPattern",
                                    "value": "8x1",
                                    "type": "string"
                                },
                                {
                                    "metaDataId": 21305,
                                    "name": "attachConfig.attachOffsets",
                                    "value": "{\"octagon\":{\"top\":-1.5,\"left\":-0.7},\"slot\":{\"top\":-1.15,\"left\":-0.4}}",
                                    "type": "string"
                                }
                            ],
                            "dependentOptions": [],
                            "dataType": "List"
                        },
                      {
                            "id": 284326,
                            "mediaUrl": "https://blinds.homedepot.com/product-images/2114da75-3085-f111-8492-0afffee37a07.png",
                            "media": {
                                "alternateText": "Double Bin",
                                "caption": null,
                                "mediaOwner": null
                            },
                            "isActive": true,
                            "internalName": "Double_Bin",
                            "shortLabel": "Double Bin",
                            "longLabel": "Double Bin",
                            "siteProductOptionChoiceShortLabel": null,
                            "siteProductOptionChoiceLongLabel": null,
                            "price": 0.0,
                            "sequence": 3,
                            "isSelected": false,
                            "isDefault": false,
                            "isBackordered": false,
                            "fillDate": null,
                            "value": null,
                            "minValue": 0.0,
                            "maxValue": 0.0,
                            "tags": [],
                            "fullPath": "LINK_WALL_PLATE_HOOKS",
                            "metaDataItems": [
                                {
                                    "metaDataId": 21099,
                                    "name": "attachConfig.attachOffsets",
                                    "value": "{\"slot\":{\"top\":0,\"left\":-0.6}}",
                                    "type": "string"
                                },
                                {
                                    "metaDataId": 21100,
                                    "name": "attachConfig.anchorPattern",
                                    "value": "4x1",
                                    "type": "string"
                                },
                                {
                                    "metaDataId": 21101,
                                    "name": "attachConfig.maxFootPrintSpan",
                                    "value": "2",
                                    "type": "string"
                                },
                                {
                                    "metaDataId": 21102,
                                    "name": "width",
                                    "value": "9.3",
                                    "type": "decimal"
                                },
                                {
                                    "metaDataId": 21103,
                                    "name": "Sku",
                                    "value": "317939861",
                                    "type": "string"
                                },
                                {
                                    "metaDataId": 21104,
                                    "name": "attachConfig.parentTypes",
                                    "value": "[\"wall-rail\"]",
                                    "type": "string"
                                },
                                {
                                    "metaDataId": 21107,
                                    "name": "height",
                                    "value": "3.75",
                                    "type": "decimal"
                                },
                                {
                                    "metaDataId": 21109,
                                    "name": "attachConfig.startAnchorPointType",
                                    "value": "slot",
                                    "type": "string"
                                }
                            ],
                            "dependentOptions": [],
                            "dataType": "List"
                        },
                        {
                            "id": 284333,
                            "mediaUrl": "https://gcc-media-assets.s3.us-east-1.amazonaws.com/Blinds/Modular+Tool+Storage/737244+-+Ryobi+Wall+Storage+Builder/737244_284333_0",
                            "media": {
                                "alternateText": "ryobi hook",
                                "caption": null,
                                "mediaOwner": null
                            },
                            "isActive": true,
                            "internalName": "_PACKOUT_4_SINGLE_STRAIGHT_HOOK",
                            "shortLabel": "PACKOUT 4\" SINGLE STRAIGHT HOOK",
                            "longLabel": "PACKOUT 4\" SINGLE STRAIGHT HOOK",
                            "siteProductOptionChoiceShortLabel": null,
                            "siteProductOptionChoiceLongLabel": null,
                            "price": 0.0,
                            "sequence": 1,
                            "isSelected": false,
                            "isDefault": false,
                            "isBackordered": false,
                            "fillDate": null,
                            "value": null,
                            "minValue": 0.0,
                            "maxValue": 0.0,
                            "tags": [],
                            "fullPath": "RYOBI_HOOKS",
                            "metaDataItems": [
                                {
                                    "metaDataId": 10848,
                                    "name": "Sku",
                                    "value": "320242444",
                                    "type": "string"
                                },
                                {
                                    "metaDataId": 19128,
                                    "name": "width",
                                    "value": "2.655",
                                    "type": "decimal"
                                },
                                {
                                    "metaDataId": 19129,
                                    "name": "height",
                                    "value": "5.65",
                                    "type": "decimal"
                                },
                                {
                                    "metaDataId": 192421,
                                    "name": "attachConfig.parentTypes",
                                    "value": "[\"wall-rail\"]",
                                    "type": "string"
                                },
                                {
                                    "metaDataId": 192425,
                                    "name": "attachConfig.anchorPattern",
                                    "value": "1x1",
                                    "type": "string"
                                },
                                {
                                    "metaDataId": 192426,
                                    "name": "attachConfig.maxFootPrintSpan",
                                    "value": "1",
                                    "type": "string"
                                },
                                {
                                    "metaDataId": 192428,
                                    "name": "attachConfig.attachVariantDimensions",
                                    "value": "{\"octagon\":{\"width\":2.655,\"height\":4.1},\"slot\":{\"width\":2.655,\"height\":5.65}}",
                                    "type": "string"
                                },
                                {
                                    "metaDataId": 192427,
                                    "name": "attachConfig.attachOffsets",
                                    "value": "{\"octagon\":{\"top\":-1.5,\"left\":0},\"slot\":{\"top\":0,\"left\":0}}",
                                    "type": "string"
                                },
                                 {
                                    "metaDataId": 20892,
                                    "name": "attachConfig.attachVariantPerspectives",
                                    "value": "{\"octagon\":1,\"slot\":0}",
                                    "type": "string"
                                },
                            ],
                            "dependentOptions": [],
                            "dataType": "List"
                        },
                        {
                            "id": 284363,
                            "mediaUrl": "https://blinds.homedepot.com/product-images/4df79196-3285-f111-8492-0afffee37a07.png",
                            "media": {
                                "alternateText": "Hanging Shelf",
                                "caption": null,
                                "mediaOwner": null
                            },
                            "isActive": true,
                            "internalName": "Hanging_Shelf",
                            "shortLabel": "Hanging Shelf",
                            "longLabel": "Hanging Shelf",
                            "siteProductOptionChoiceShortLabel": null,
                            "siteProductOptionChoiceLongLabel": null,
                            "price": 0.0,
                            "sequence": 6,
                            "isSelected": false,
                            "isDefault": false,
                            "isBackordered": false,
                            "fillDate": null,
                            "value": null,
                            "minValue": 0.0,
                            "maxValue": 0.0,
                            "tags": [],
                            "fullPath": "LINK_WALL_PLATE_SHELF",
                            "metaDataItems": [
                                {
                                    "metaDataId": 20885,
                                    "name": "attachConfig.maxFootPrintSpan",
                                    "value": "2",
                                    "type": "string"
                                },
                                {
                                    "metaDataId": 20886,
                                    "name": "attachConfig.anchorPattern",
                                    "value": "8x1",
                                    "type": "string"
                                },
                                {
                                    "metaDataId": 20887,
                                    "name": "attachConfig.anchorPointTypes",
                                    "value": "[\"octagon\",\"slot\"]",
                                    "type": "string"
                                },
                                {
                                    "metaDataId": 20888,
                                    "name": "attachConfig.parentTypes",
                                    "value": "[\"wall-rail\"]",
                                    "type": "string"
                                },
                                {
                                    "metaDataId": 20889,
                                    "name": "height",
                                    "value": "5.75",
                                    "type": "decimal"
                                },
                                {
                                    "metaDataId": 20890,
                                    "name": "width",
                                    "value": "21.2",
                                    "type": "decimal"
                                },
                                {
                                    "metaDataId": 20891,
                                    "name": "Sku",
                                    "value": "317939879",
                                    "type": "string"
                                },
                                {
                                    "metaDataId": 20894,
                                    "name": "attachConfig.attachOffsets",
                                    "value": "{\"octagon\":{\"top\":-1.5,\"left\":-1},\"slot\":{\"top\":-1.5,\"left\":-1.25}}",
                                    "type": "string"
                                },
                                {
                                    "metaDataId": 20896,
                                    "name": "attachConfig.startAnchorPointType",
                                    "value": "slot",
                                    "type": "string"
                                }
                            ],
                            "dependentOptions": [],
                            "dataType": "List"
                        },

                          {
                            "id": 284306,
                            "mediaUrl": "https://blinds.homedepot.com/product-images/5aae6896-2985-f111-8492-0afffee37a07.png",
                            "media": {
                                "alternateText": "Mesh Basket",
                                "caption": null,
                                "mediaOwner": null
                            },
                            "isActive": true,
                            "internalName": "Mesh_Basket",
                            "shortLabel": "Mesh Basket",
                            "longLabel": "Mesh Basket",
                            "siteProductOptionChoiceShortLabel": null,
                            "siteProductOptionChoiceLongLabel": null,
                            "price": 0.0,
                            "sequence": 1,
                            "isSelected": false,
                            "isDefault": false,
                            "isBackordered": false,
                            "fillDate": null,
                            "value": null,
                            "minValue": 0.0,
                            "maxValue": 0.0,
                            "tags": [],
                            "fullPath": "LINK_WALL_PLATE_BASKET",
                            "metaDataItems": [
                                {
                                    "metaDataId": 20949,
                                    "name": "attachConfig.anchorPattern",
                                    "value": "8x1",
                                    "type": "string"
                                },
                                {
                                    "metaDataId": 20950,
                                    "name": "attachConfig.maxFootPrintSpan",
                                    "value": "2",
                                    "type": "string"
                                },
                                {
                                    "metaDataId": 20952,
                                    "name": "attachConfig.parentTypes",
                                    "value": "[\"wall-rail\"]",
                                    "type": "string"
                                },

                                {
                                    "metaDataId": 20954,
                                    "name": "attachConfig.startAnchorPointType",
                                    "value": "slot",
                                    "type": "string"
                                },
                                {
                                    "metaDataId": 20955,
                                    "name": "height",
                                    "value": "14",
                                    "type": "decimal"
                                },
                                {
                                    "metaDataId": 20956,
                                    "name": "width",
                                    "value": "21",
                                    "type": "decimal"
                                },
                                {
                                    "metaDataId": 20957,
                                    "name": "Sku",
                                    "value": "330817779",
                                    "type": "string"
                                }
                            ],
                            "dependentOptions": [],
                            "dataType": "List"
                        },
                         {
                            "id": 284307,
                            "mediaUrl": "https://blinds.homedepot.com/product-images/0cd55bb2-2985-f111-8492-0afffee37a07.png",
                            "media": {
                                "alternateText": "Wire Basket",
                                "caption": null,
                                "mediaOwner": null
                            },
                            "isActive": true,
                            "internalName": "Wire_Basket",
                            "shortLabel": "Wire Basket",
                            "longLabel": "Wire Basket",
                            "siteProductOptionChoiceShortLabel": null,
                            "siteProductOptionChoiceLongLabel": null,
                            "price": 0.0,
                            "sequence": 2,
                            "isSelected": false,
                            "isDefault": false,
                            "isBackordered": false,
                            "fillDate": null,
                            "value": null,
                            "minValue": 0.0,
                            "maxValue": 0.0,
                            "tags": [],
                            "fullPath": "LINK_WALL_PLATE_BASKET",
                            "metaDataItems": [
                                {
                                    "metaDataId": 20940,
                                    "name": "Sku",
                                    "value": "330817684",
                                    "type": "string"
                                },
                                {
                                    "metaDataId": 20941,
                                    "name": "width",
                                    "value": "15.5",
                                    "type": "decimal"
                                },
                                {
                                    "metaDataId": 20942,
                                    "name": "height",
                                    "value": "7.1",
                                    "type": "decimal"
                                },
                                {
                                    "metaDataId": 20943,
                                    "name": "attachConfig.startAnchorPointType",
                                    "value": "slot",
                                    "type": "string"
                                },

                                {
                                    "metaDataId": 20945,
                                    "name": "attachConfig.parentTypes",
                                    "value": "[\"wall-rail\"]",
                                    "type": "string"
                                },

                                {
                                    "metaDataId": 20947,
                                    "name": "attachConfig.maxFootPrintSpan",
                                    "value": "2",
                                    "type": "string"
                                },
                                {
                                    "metaDataId": 20948,
                                    "name": "attachConfig.anchorPattern",
                                    "value": "6x1",
                                    "type": "string"
                                }
                            ],
                            "dependentOptions": [],
                            "dataType": "List"
                        },
                        {
                            "id": 284358,
                            "mediaUrl": "https://blinds.homedepot.com/is/image/blinds/737244_284358_0?fmt=png",
                            "media": { "alternateText": "Shelf Bracket (mock)", "caption": null, "mediaOwner": null },
                            "isActive": true,
                            "internalName": "MOCK_ISB_SHELF_BRACKET",
                            "shortLabel": "Shelf Bracket (mock)",
                            "longLabel": "Shelf Bracket (mock)",
                            "siteProductOptionChoiceShortLabel": null,
                            "siteProductOptionChoiceLongLabel": null,
                            "price": 0.0,
                            "sequence": 90,
                            "isSelected": false,
                            "isDefault": false,
                            "isBackordered": false,
                            "fillDate": null,
                            "value": null,
                            "minValue": 0.0,
                            "maxValue": 0.0,
                            "tags": [],
                            "fullPath": "RYOBI_HOOKS",
                            "metaDataItems": [
                                { "metaDataId": 900001, "name": "Sku", "value": "324536431", "type": "string" },
                                { "metaDataId": 900002, "name": "width", "value": "3.3", "type": "decimal" },
                                { "metaDataId": 900003, "name": "height", "value": "4.5", "type": "decimal" },
                                { "metaDataId": 900004, "name": "attachConfig.parentTypes", "value": "[\"wall-rail\"]", "type": "string" },
                                {
                                    "metaDataId": 192427,
                                    "name": "attachConfig.attachOffsets",
                                    // Mocked estimate for the octagon variant (no real design
                                    // measurement available yet) — mirrors the known slot offset
                                    // as a placeholder so a bracket landing on octagon at least
                                    // gets a non-zero offset instead of silently falling back to
                                    // {0,0}. Replace with real per-type values once available.
                                    "value": "{\"slot\":{\"top\":-1,\"left\":-0.3}}",
                                    "type": "string"
                                },
                                { "metaDataId": 900006, "name": "attachConfig.maxFootPrintSpan", "value": "1", "type": "string" },
                                { "metaDataId": 900007, "name": "attachConfig.anchorPointTypes", "value": "[\"octagon\",\"slot\"]", "type": "string" },
                                { "metaDataId": 900008, "name": "soldAsBundleOnly", "value": "true", "type": "string" },
                            ],
                            "dependentOptions": [],
                            "dataType": "List"
                        },
                        {
                            "id": 284360,
                            "mediaUrl": "https://placehold.co/240x80/e0e0e0/666666.png?text=Single+Wire+Shelf+Part",
                            "media": { "alternateText": "Single Wire Shelf part (mock)", "caption": null, "mediaOwner": null },
                            "isActive": true,
                            "internalName": "MOCK_ISB_SINGLE_WIRE_SHELF_PART",
                            "shortLabel": "Single Wire Shelf part (mock)",
                            "longLabel": "Single Wire Shelf part (mock)",
                            "siteProductOptionChoiceShortLabel": null,
                            "siteProductOptionChoiceLongLabel": null,
                            "price": 0.0,
                            "sequence": 91,
                            "isSelected": false,
                            "isDefault": false,
                            "isBackordered": false,
                            "fillDate": null,
                            "value": null,
                            "minValue": 0.0,
                            "maxValue": 0.0,
                            "tags": [],
                            "fullPath": "RYOBI_HOOKS",
                            "metaDataItems": [
                                { "metaDataId": 900011, "name": "Sku", "value": "324536604", "type": "string" },
                                { "metaDataId": 900012, "name": "width", "value": "21", "type": "decimal" },
                                { "metaDataId": 900013, "name": "height", "value": "1.35", "type": "decimal" },
                                { "metaDataId": 900014, "name": "attachConfig.parentTypes", "value": "[\"wall-rail\"]", "type": "string" },
                                // { "metaDataId": 900015, "name": "attachConfig.anchorPattern", "value": "1x1", "type": "string" },
                                {
                                    "metaDataId": 186540,
                                    "name": "anchorPointConfig.attachVariantPerspectives",
                                    "value": "{\"octagon\":0,\"slot\":0}",
                                    "type": "string"
                                },
                                { "metaDataId": 900016, "name": "attachConfig.maxFootPrintSpan", "value": "2", "type": "string" },
                                {
                                    "metaDataId": 20894,
                                    "name": "attachConfig.attachOffsets",
                                    "value": "{\"octagon\":{\"top\":0,\"left\":-1.4},\"slot\":{\"top\":-1.5,\"left\":1.3}}",
                                    "type": "string"
                                },
                                { "metaDataId": 900017, "name": "attachConfig.anchorPointTypes", "value": "[\"octagon\",\"slot\"]", "type": "string" },
                                { "metaDataId": 900030, "name": "attachConfig.zIndex", "value": "1000", "type": "string" },
                                { "metaDataId": 900018, "name": "soldAsBundleOnly", "value": "true", "type": "string" },
                            ],
                            "dependentOptions": [],
                            "dataType": "List"
                        },
                        {
                            "id": 284359,
                            "mediaUrl": "https://placehold.co/240x80/e0e0e0/666666.png?text=Solid+Shelf+Part",
                            "media": { "alternateText": "Solid Shelf part (mock)", "caption": null, "mediaOwner": null },
                            "isActive": true,
                            "internalName": "MOCK_ISB_SOLID_SHELF_PART",
                            "shortLabel": "Solid Shelf part (mock)",
                            "longLabel": "Solid Shelf part (mock)",
                            "siteProductOptionChoiceShortLabel": null,
                            "siteProductOptionChoiceLongLabel": null,
                            "price": 0.0,
                            "sequence": 92,
                            "isSelected": false,
                            "isDefault": false,
                            "isBackordered": false,
                            "fillDate": null,
                            "value": null,
                            "minValue": 0.0,
                            "maxValue": 0.0,
                            "tags": [],
                            "fullPath": "RYOBI_HOOKS",
                            "metaDataItems": [
                                { "metaDataId": 900021, "name": "Sku", "value": "324536656", "type": "string" },
                                { "metaDataId": 900022, "name": "width", "value": "21.3", "type": "decimal" },
                                { "metaDataId": 900023, "name": "height", "value": "1.3", "type": "decimal" },
                                { "metaDataId": 900024, "name": "attachConfig.parentTypes", "value": "[\"wall-rail\"]", "type": "string" },
                                {
                                    "metaDataId": 186540,
                                    "name": "anchorPointConfig.attachVariantPerspectives",
                                    "value": "{\"octagon\":0,\"slot\":0}",
                                    "type": "string"
                                },
                                { "metaDataId": 900026, "name": "attachConfig.maxFootPrintSpan", "value": "2", "type": "string" },
                                {
                                    "metaDataId": 900029,
                                    "name": "attachConfig.attachOffsets",
                                    // Same spec as the Wire Shelf part (284360) — same physical
                                    // span between the same two brackets, per catalog confirmation.
                                    "value": "{\"octagon\":{\"top\":0,\"left\":-1.4},\"slot\":{\"top\":-1.5,\"left\":1.3}}",
                                    "type": "string"
                                },
                                { "metaDataId": 900027, "name": "attachConfig.anchorPointTypes", "value": "[\"octagon\",\"slot\"]", "type": "string" },
                                { "metaDataId": 900031, "name": "attachConfig.zIndex", "value": "1000", "type": "string" },
                                { "metaDataId": 900028, "name": "soldAsBundleOnly", "value": "true", "type": "string" }
                            ],
                            "dependentOptions": [],
                            "dataType": "List"
                        },
                        {
                            "id": 280101,
                            "mediaUrl": "https://placehold.co/240x80/e0e0e0/666666.png?text=Single+Wire+Shelf",
                            "media": { "alternateText": "Single Wire Shelf (mock ISB)", "caption": null, "mediaOwner": null },
                            "isActive": true,
                            "internalName": "MOCK_ISB_SINGLE_WIRE_SHELF",
                            "shortLabel": "Single Wire Shelf (mock)",
                            "longLabel": "Single Wire Shelf (mock)",
                            "siteProductOptionChoiceShortLabel": null,
                            "siteProductOptionChoiceLongLabel": null,
                            "price": 0.0,
                            "sequence": 95,
                            "isSelected": false,
                            "isDefault": false,
                            "isBackordered": false,
                            "fillDate": null,
                            "value": null,
                            "minValue": 0.0,
                            "maxValue": 0.0,
                            "tags": [],
                            "fullPath": "RYOBI_HOOKS",
                            "metaDataItems": [
                                { "metaDataId": 900101, "name": "BundleDesign", "value": "8f0af0eb-0000-0000-0000-mock00000011", "type": "string" },
                                { "metaDataId": 900102, "name": "IsInseparableBundle", "value": "true", "type": "string" },
                                { "metaDataId": 900103, "name": "gridColumns", "value": "3", "type": "int" },
                                { "metaDataId": 900104, "name": "gridRows", "value": "1", "type": "int" },
                                { "metaDataId": 900105, "name": "width", "value": "24.25", "type": "decimal" },
                                { "metaDataId": 900106, "name": "height", "value": "3.8", "type": "decimal" },
                                { "metaDataId": 900107, "name": "attachConfig.parentTypes", "value": "[\"wall-rail\"]", "type": "string" },
                                { "metaDataId": 900108, "name": "attachConfig.anchorPattern", "value": "9x1", "type": "string" },
                                // maxFootPrintSpan: 3 (not 2) so a 9-column span can start
                                // right at a rail-to-rail seam anchor too — that anchor sits
                                // at its own rail's LAST column, contributing only 1 column
                                // of the needed 9 before needing to hop, so reaching the far
                                // end needs 2 hops (up to 14 more columns), not just 1.
                                { "metaDataId": 900109, "name": "attachConfig.maxFootPrintSpan", "value": "3", "type": "string" },
                                { "metaDataId": 900110, "name": "attachConfig.anchorPointTypes", "value": "[\"octagon\",\"slot\"]", "type": "string" },
                                {
                                    "metaDataId": 20896,
                                    "name": "attachConfig.startAnchorPointType",
                                    "value": "slot",
                                    "type": "string"
                                }
                            ],
                            "dependentOptions": [],
                            "dataType": "List"
                        },
                        {
                            "id": 280102,
                            "mediaUrl": "https://placehold.co/240x80/e0e0e0/666666.png?text=Single+Solid+Shelf",
                            "media": { "alternateText": "Single Solid Shelf (mock ISB)", "caption": null, "mediaOwner": null },
                            "isActive": true,
                            "internalName": "MOCK_ISB_SINGLE_SOLID_SHELF",
                            "shortLabel": "Single Solid Shelf (mock)",
                            "longLabel": "Single Solid Shelf (mock)",
                            "siteProductOptionChoiceShortLabel": null,
                            "siteProductOptionChoiceLongLabel": null,
                            "price": 0.0,
                            "sequence": 96,
                            "isSelected": false,
                            "isDefault": false,
                            "isBackordered": false,
                            "fillDate": null,
                            "value": null,
                            "minValue": 0.0,
                            "maxValue": 0.0,
                            "tags": [],
                            "fullPath": "RYOBI_HOOKS",
                            "metaDataItems": [
                                { "metaDataId": 900111, "name": "BundleDesign", "value": "8f0af0eb-0000-0000-0000-mock00000012", "type": "string" },
                                { "metaDataId": 900112, "name": "IsInseparableBundle", "value": "true", "type": "string" },
                                { "metaDataId": 900113, "name": "gridColumns", "value": "3", "type": "int" },
                                { "metaDataId": 900114, "name": "gridRows", "value": "1", "type": "int" },
                                // Same spec/geometry as Single Wire Shelf (280101) — only the shelf sku/choiceId differs.
                                { "metaDataId": 900115, "name": "width", "value": "24.25", "type": "decimal" },
                                { "metaDataId": 900116, "name": "height", "value": "3.8", "type": "decimal" },
                                { "metaDataId": 900117, "name": "attachConfig.parentTypes", "value": "[\"wall-rail\"]", "type": "string" },
                                { "metaDataId": 900118, "name": "attachConfig.anchorPattern", "value": "9x1", "type": "string" },
                                // Same reasoning as Single Wire Shelf (280101) above —
                                // maxFootPrintSpan: 3 lets the span start at a seam anchor.
                                { "metaDataId": 900119, "name": "attachConfig.maxFootPrintSpan", "value": "3", "type": "string" },
                                { "metaDataId": 900120, "name": "attachConfig.anchorPointTypes", "value": "[\"octagon\",\"slot\"]", "type": "string" },
                                {
                                    "metaDataId": 20897,
                                    "name": "attachConfig.startAnchorPointType",
                                    "value": "slot",
                                    "type": "string"
                                }
                            ],
                            "dependentOptions": [],
                            "dataType": "List"
                        },
                        {
                            "id": 280103,
                            "mediaUrl": "https://placehold.co/240x80/e0e0e0/666666.png?text=Double+Wire+Shelf",
                            "media": { "alternateText": "Double Wire Shelf (mock ISB)", "caption": null, "mediaOwner": null },
                            "isActive": true,
                            "internalName": "MOCK_ISB_DOUBLE_WIRE_SHELF",
                            "shortLabel": "Double Wire Shelf (mock)",
                            "longLabel": "Double Wire Shelf (mock)",
                            "siteProductOptionChoiceShortLabel": null,
                            "siteProductOptionChoiceLongLabel": null,
                            "price": 0.0,
                            "sequence": 97,
                            "isSelected": false,
                            "isDefault": false,
                            "isBackordered": false,
                            "fillDate": null,
                            "value": null,
                            "minValue": 0.0,
                            "maxValue": 0.0,
                            "tags": [],
                            "fullPath": "RYOBI_HOOKS",
                            "metaDataItems": [
                                { "metaDataId": 900121, "name": "BundleDesign", "value": "8f0af0eb-0000-0000-0000-mock00000013", "type": "string" },
                                { "metaDataId": 900122, "name": "IsInseparableBundle", "value": "true", "type": "string" },
                                { "metaDataId": 900123, "name": "gridColumns", "value": "3", "type": "int" },
                                { "metaDataId": 900124, "name": "gridRows", "value": "1", "type": "int" },
                                // 3 brackets + 2 wire shelves — wider span than the single variant, so
                                // width/anchorPattern scale up accordingly (see
                                // wallStorage-isb-doubleWireShelf.mock.js for the exact Origin geometry).
                                // Real total span = 2 shelf-widths + 1 bracket-width = 2*21 + 3.3 = 45.3in;
                                // bracket3 lands on the real 17th distinct anchor (0-indexed 16), not the
                                // 19th — matches the single-shelf variant's own already-correct width
                                // (24.25in ≈ 1 shelf-width + 1 bracket-width = 21 + 3.3).
                                { "metaDataId": 900125, "name": "width", "value": "45.3", "type": "decimal" },
                                { "metaDataId": 900126, "name": "height", "value": "3.8", "type": "decimal" },
                                { "metaDataId": 900127, "name": "attachConfig.parentTypes", "value": "[\"wall-rail\"]", "type": "string" },
                                { "metaDataId": 900128, "name": "attachConfig.anchorPattern", "value": "17x1", "type": "string" },
                                { "metaDataId": 900129, "name": "attachConfig.maxFootPrintSpan", "value": "4", "type": "string" },
                                { "metaDataId": 900130, "name": "attachConfig.anchorPointTypes", "value": "[\"octagon\",\"slot\"]", "type": "string" },
                                {
                                    "metaDataId": 20898,
                                    "name": "attachConfig.startAnchorPointType",
                                    "value": "slot",
                                    "type": "string"
                                }
                            ],
                            "dependentOptions": [],
                            "dataType": "List"
                        },
                        {
                            "id": 280104,
                            "mediaUrl": "https://placehold.co/240x80/e0e0e0/666666.png?text=Double+Solid+Shelf",
                            "media": { "alternateText": "Double Solid Shelf (mock ISB)", "caption": null, "mediaOwner": null },
                            "isActive": true,
                            "internalName": "MOCK_ISB_DOUBLE_SOLID_SHELF",
                            "shortLabel": "Double Solid Shelf (mock)",
                            "longLabel": "Double Solid Shelf (mock)",
                            "siteProductOptionChoiceShortLabel": null,
                            "siteProductOptionChoiceLongLabel": null,
                            "price": 0.0,
                            "sequence": 98,
                            "isSelected": false,
                            "isDefault": false,
                            "isBackordered": false,
                            "fillDate": null,
                            "value": null,
                            "minValue": 0.0,
                            "maxValue": 0.0,
                            "tags": [],
                            "fullPath": "RYOBI_HOOKS",
                            "metaDataItems": [
                                { "metaDataId": 900131, "name": "BundleDesign", "value": "8f0af0eb-0000-0000-0000-mock00000014", "type": "string" },
                                { "metaDataId": 900132, "name": "IsInseparableBundle", "value": "true", "type": "string" },
                                { "metaDataId": 900133, "name": "gridColumns", "value": "3", "type": "int" },
                                { "metaDataId": 900134, "name": "gridRows", "value": "1", "type": "int" },
                                // 3 brackets + 2 solid shelves — same geometry as Double Wire Shelf
                                // (280103), only the shelf sku/choiceId differs.
                                { "metaDataId": 900135, "name": "width", "value": "45.3", "type": "decimal" },
                                { "metaDataId": 900136, "name": "height", "value": "3.8", "type": "decimal" },
                                { "metaDataId": 900137, "name": "attachConfig.parentTypes", "value": "[\"wall-rail\"]", "type": "string" },
                                { "metaDataId": 900138, "name": "attachConfig.anchorPattern", "value": "17x1", "type": "string" },
                                { "metaDataId": 900139, "name": "attachConfig.maxFootPrintSpan", "value": "3", "type": "string" },
                                { "metaDataId": 900140, "name": "attachConfig.anchorPointTypes", "value": "[\"octagon\",\"slot\"]", "type": "string" },
                                {
                                    "metaDataId": 20899,
                                    "name": "attachConfig.startAnchorPointType",
                                    "value": "slot",
                                    "type": "string"
                                }
                            ],
                            "dependentOptions": [],
                            "dataType": "List"
                        },
                    ],
          sequence: 1,
          groupSequence: 1,
          tags: [],
          choiceGroups: []
        },
      ]
    }
  ],
  visualizedOptions: [],
  choiceValueRanges: null,
  isVisualized: false,
  additionalDetails: null
};
export const packoutProductInfoMockData = {
  ProductId: 711698,
  PartnerProductId: 338909191,
  ProductName: 'PACKOUT Wall Plate Builder',
  Brand: 'Milwaukee',
  IsDraft: false,
  DraftProductLastUpdatedAt: '0001-01-01T00:00:00',
  GalleryImages: [
    {
      ImageUrl: '\\SqlImages\\d91edcca-9661-ec11-949a-0a986990730e.jpg',
      Caption: null
    }
  ],
  Attributes: {
    SnapConfig: '{"overlapSnapThresholdInches":0.5,"snapDistanceInches":4,"alignTopOnSameTypeSnap":true,"alignTopOnDifferentTypeSnap":false}',
    "Scene7Folder": "Blinds/Modular Tool Storage/711698 - Packout Wall Plate Builder",
    "Matrix": "4:4",
    "MatrixSegments": "{\"Segments\": [{\"Start\":[0,0,0],\"End\":[1,3,0]},{\"Start\":[2,0,0],\"End\":[3,3,0]}]}",
    "DisplayName": "PACKOUT",
    "PortableStorageCallout": "False",
    "GridVizConfig": "{\"renderType\":\"grid\",\"numOfCols\":9,\"numOfRows\":3,\"gridBorderStyle\":\"1px solid #ccc\",\"padding\":3,\"cellWidth\":10.25,\"cellHeight\":20,\"strokeStyle\":\"#808080\",\"lineWidth\":1,\"showGrid\":false}",
    WallDimensions: '{"width":137.25,"height":104}',
    IntroGuideSlides: '{"slideData":[{"image":"https://gcc-visualizer-images.s3.us-east-1.amazonaws.com/is/image/blinds/onboarding_1_parent.gif","description":"Select a Wall Plate and drop it onto your wall."},{"image":"https://gcc-visualizer-images.s3.us-east-1.amazonaws.com/is/image/blinds/onboarding_2_child.gif","description":"Add any hooks, kits, or other products to your Wall Plate."},{"image":"https://gcc-visualizer-images.s3.us-east-1.amazonaws.com/is/image/blinds/onboarding_3_dnd.gif","description":"Rearrange to build your perfect layout."}]}',
  }
};
export const ryobiProductInfoMockData = {
  ProductId: 737244,
  PartnerProductId: 344131957,
  ProductName: 'Ryobi Wall Rail Builder',
  Brand: 'Ryobi',
  IsDraft: false,
  DraftProductLastUpdatedAt: '0001-01-01T00:00:00',
  GalleryImages: [
    {
      ImageUrl: '\\SqlImages\\d91edcca-9661-ec11-949a-0a986990730e.jpg',
      Caption: null
    }
  ],
  Attributes: {
    SnapConfig: '{"overlapSnapThresholdInches":0.5,"snapDistanceInches":2,"overlap":{"left":1.42, "right":1.42},"alignTopOnSameTypeSnap":true,"alignTopOnDifferentTypeSnap":false}',
    "Scene7Folder": "Blinds/Modular Tool Storage/711698 - Packout Wall Plate Builder",
    "Matrix": "4:4",
    "MatrixSegments": "{\"Segments\": [{\"Start\":[0,0,0],\"End\":[1,3,0]},{\"Start\":[2,0,0],\"End\":[3,3,0]}]}",
    "DisplayName": "PACKOUT",
    "PortableStorageCallout": "False",
    "GridVizConfig": "{\"renderType\":\"grid\",\"numOfCols\":9,\"numOfRows\":3,\"gridBorderStyle\":\"1px solid #ccc\",\"padding\":3,\"cellWidth\":10.25,\"cellHeight\":20,\"strokeStyle\":\"#808080\",\"lineWidth\":1,\"showGrid\":false}",
    WallDimensions: '{"width":90.25,"height":60}',
  }
};
